//! DO NOT EDIT THIS FILE MANUALLY!
//! IT IS AUTO-GENERATED FROM: protos-backend-logging/src/main/proto/faire/logging/pod.proto
//! RUN `yarn nx regenerate web-api` TO REGENERATE.

import { FaireOncall } from '@faire/types-observability-api/faire/logging/FaireOncall';
import { FairePillar } from '@faire/types-observability-api/faire/logging/FairePillar';
import { FairePod } from '@faire/types-observability-api/faire/logging/FairePod';

const deprecatedForFairePod: Partial<Record<FairePod, boolean>> = {
  FAIRE_POD_UNKNOWN: true,
  FAIRE_POD_ANTI_ABUSE: undefined,
  FAIRE_POD_APPAREL: true,
  FAIRE_POD_APPAREL_BRAND: true,
  FAIRE_POD_APPAREL_EVENTS: true,
  FAIRE_POD_APPAREL_PREORDER: true,
  FAIRE_POD_APPAREL_RETAILER: true,
  FAIRE_POD_BRAND_ACQUISITION: true,
  FAIRE_POD_BRAND_GROWTH: true,
  FAIRE_POD_BRAND_MARKETPLACE_QUALITY: true,
  FAIRE_POD_BRAND_ONBOARDING: true,
  FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM: undefined,
  FAIRE_POD_BRAND_ORDER_MANAGEMENT: true,
  FAIRE_POD_BRAND_FAIRE_DIRECT: true,
  FAIRE_POD_CATEGORY_INCUBATION: true,
  FAIRE_POD_DATA: undefined,
  FAIRE_POD_DISCOVERY_AI: true,
  FAIRE_POD_DISCOVERY_AE: undefined,
  FAIRE_POD_DISCOVERY_LOGGING: undefined,
  FAIRE_POD_FAIRE_FOUNDATIONS: true,
  FAIRE_POD_INTEGRATIONS: true,
  FAIRE_POD_INTERNAL_TOOLS: true,
  FAIRE_POD_INTERNATIONAL: true,
  FAIRE_POD_INTERNATIONAL_BRAND_GROWTH: true,
  FAIRE_POD_INTERNATIONAL_BRAND: true,
  FAIRE_POD_INTERNATIONAL_LAUNCH: true,
  FAIRE_POD_INTERNATIONAL_PLATFORM: true,
  FAIRE_POD_MARKETS: true,
  FAIRE_POD_RETAILER_PRICING: true,
  FAIRE_POD_SHIPPING: undefined,
  FAIRE_POD_MARKETPLACE_QUALITY: undefined,
  FAIRE_POD_MOBILE: true,
  FAIRE_POD_MOBILE_STRIKE: true,
  FAIRE_POD_MOBILE_CORE: true,
  FAIRE_POD_MOBILE_PLATFORM: true,
  FAIRE_POD_MOBILE_EXPANSION: true,
  FAIRE_POD_MOBILE_INTERNATIONAL: true,
  FAIRE_POD_MULTI_SERVICE: true,
  FAIRE_POD_PLATFORM: true,
  FAIRE_POD_PLATFORM_CONTROL: true,
  FAIRE_POD_PLATFORM_SCALE: true,
  FAIRE_POD_PLATFORM_RELIABILITY: undefined,
  FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS: undefined,
  FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCE: true,
  FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY: undefined,
  FAIRE_POD_PLATFORM_TAP: true,
  FAIRE_POD_BRAND_INFRASTRUCTURE: true,
  FAIRE_POD_PREORDERS: true,
  FAIRE_POD_PRICING: true,
  FAIRE_POD_BRAND_PRICING: true,
  FAIRE_POD_QUALITY: true,
  FAIRE_POD_RISK: true,
  FAIRE_POD_SECURITY: undefined,
  FAIRE_POD_RETAILER_LIFECYCLE: true,
  FAIRE_POD_RETAILER_CONFIDENCE: true,
  FAIRE_POD_RETAILER_GROWTH: true,
  FAIRE_POD_RETAILER_ACTIVATION: undefined,
  FAIRE_POD_RETAILER_ONBOARDING: undefined,
  FAIRE_POD_RETAILER_DISCOVERY: true,
  FAIRE_POD_INSIDER: undefined,
  FAIRE_POD_UNASSIGNED: undefined,
  FAIRE_POD_BRAND_UNASSIGNED: undefined,
  FAIRE_POD_WEB_PLATFORM: true,
  FAIRE_POD_CLIENT_TOOLS: true,
  FAIRE_POD_RETAILER_UNDERWRITING: true,
  FAIRE_POD_ORDER_WRITING: true,
  FAIRE_POD_LOCALIZATION: true,
  FAIRE_POD_BRAND_MARKETPLACE_SUCCESS: true,
  FAIRE_POD_STABLE_STAPLES: true,
  FAIRE_POD_FINANCIAL_PRODUCTS: true,
  FAIRE_POD_UPMARKET: true,
  FAIRE_POD_RETAILER_INSPIRE: true,
  FAIRE_POD_RETAILER_SEARCH: true,
  FAIRE_POD_RETAILER_CHECKOUT: true,
  FAIRE_POD_RETAILER_ACQUISITION: undefined,
  FAIRE_POD_RETAILER_EVALUATE: true,
  FAIRE_POD_FAIRE_DIRECT_REWARDS: true,
  FAIRE_POD_FAIRE_DIRECT_CRM: true,
  FAIRE_POD_FAIRE_DIRECT_PROSPECTING: true,
  FAIRE_POD_APPAREL_INTEGRATIONS: true,
  FAIRE_POD_BRAND_F30D_LIFECYCLE: true,
  FAIRE_POD_INTERNATIONAL_TRANSLATION: true,
  FAIRE_POD_INVOICING_AND_SUPPORT_EXPERIENCE: true,
  FAIRE_POD_VAT_INTL_CX: true,
  FAIRE_POD_INTERNATIONAL_CX: true,
  FAIRE_POD_XB_SHIPPING: true,
  FAIRE_POD_SHIPPING_EXPERIENCE: true,
  FAIRE_POD_RETAILER_INFRASTRUCTURE: true,
  FAIRE_POD_RETAILER_TAXONOMY: true,
  FAIRE_POD_FOOD_AND_BEVERAGE: true,
  FAIRE_POD_UPMARKET_GROWTH: true,
  FAIRE_POD_UPMARKET_EXPERIENCE: true,
  FAIRE_POD_FREIGHT_MARGIN: true,
  FAIRE_POD_RETAILER_REORDER: true,
  FAIRE_POD_BRAND_ENTERPRISE: true,
  FAIRE_POD_SLATE_DESIGN_SYSTEM: true,
  FAIRE_POD_DESIGN_PLATFORM: undefined,
  FAIRE_POD_SEARCH_INFRASTRUCTURE: true,
  FAIRE_POD_RETAILER_CART_SERVICE: true,
  FAIRE_POD_UPMARKET_TEAM_MANAGEMENT: true,
  FAIRE_POD_UPMARKET_TOOLING: true,
  FAIRE_POD_RETENTION_EXPERIENCE: true,
  FAIRE_POD_RETAILER_SEO: true,
  FAIRE_POD_BRAND_SERVICE_STANDARDS: true,
  FAIRE_POD_SUPPLY_INTEGRITY: true,
  FAIRE_POD_RETAILER_SUCCESS: true,
  FAIRE_POD_THEMATIC_DISCOVERY: true,
  FAIRE_POD_TAXONOMY: true,
  FAIRE_POD_SEARCH_EXPERIENCE: true,
  FAIRE_POD_INSPIRE: undefined,
  FAIRE_POD_SEARCH_RANKING_ALGORITHMS: undefined,
  FAIRE_POD_DISCOVERY_PAID_PLACEMENT: true,
  FAIRE_POD_GROWTH_MOBILE: undefined,
  FAIRE_POD_COMMUNICATIONS_PLATFORM: true,
  FAIRE_POD_OPEN_WITH_FAIRE: true,
  FAIRE_POD_COMMISSION: true,
  FAIRE_POD_FAIRE_DIRECT_GROWTH: undefined,
  FAIRE_POD_SHOPIFY: true,
  FAIRE_POD_RETAILER_POS_INTEGRATIONS: true,
  FAIRE_POD_RETAILER_TOFU: true,
  FAIRE_POD_BROWSE: true,
  FAIRE_POD_DATA_TEAM_FINANCIAL_PRODUCTS: undefined,
  FAIRE_POD_RECOMMENDATIONS: true,
  FAIRE_POD_SEARCH_EXPERIENCE_ACCELERATOR: true,
  FAIRE_POD_INTERNATIONAL_FOUNDATIONS: true,
  FAIRE_POD_SUPPORT_EXPERIENCE: true,
  FAIRE_POD_BRAND_CATALOG_COMPLETENESS: true,
  FAIRE_POD_GROWTH_PLATFORM: undefined,
  FAIRE_POD_RETAILER_ORDER_PLACEMENT: true,
  FAIRE_POD_RETAILER_ORDER_MANAGEMENT: true,
  FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT: true,
  FAIRE_POD_BRAND_PRICING_AND_REORDERS: true,
  FAIRE_POD_BRAND_CATALOG_COMPLETENESS_AND_BRAND_PROGRAMS: true,
  FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES: undefined,
  FAIRE_POD_DISCOVERY_INFRA_ENABLEMENT: undefined,
  FAIRE_POD_EXPERIMENT_PLATFORM: true,
  FAIRE_POD_KNOWLEDGE_GRAPH: undefined,
  FAIRE_POD_PLATFORM_PRODUCTIVITY: true,
  FAIRE_POD_DISCOVERY_PRODUCT_PLATFORM: undefined,
  FAIRE_POD_PERSONALIZATION: undefined,
  FAIRE_POD_BRAND_CATALOG_GROWTH: undefined,
  FAIRE_POD_SEARCH_QUERY_UNDERSTANDING_AND_RETRIEVAL: undefined,
  FAIRE_POD_CORE_DATA_INFRA: undefined,
  FAIRE_POD_PP_ADS_MANAGER: true,
  FAIRE_POD_PP_ADS_DELIVERY: true,
  FAIRE_POD_RETAILER_GROWTH_DATA_SCIENCE: undefined,
  FAIRE_POD_BRAND_DATA_SCIENCE: undefined,
  FAIRE_POD_DATA_TEAM_INSIDER_AND_SHIPPING_COSTS: undefined,
  FAIRE_POD_VALUE_MOBILE: undefined,
  FAIRE_POD_AI_PLATFORM: undefined,
  FAIRE_POD_OPS_ENABLEMENT: true,
  FAIRE_POD_EVALUATE: undefined,
  FAIRE_POD_ADS: true,
  FAIRE_POD_ADS_DELIVERY: undefined,
  FAIRE_POD_ADS_MANAGER: true,
  FAIRE_POD_ADVERTISER_GROWTH: undefined,
  FAIRE_POD_ADS_BIDDING: undefined,
  FAIRE_POD_BRAND_PLATFORM: undefined,
  FAIRE_POD_BRAND_PLATFORM_COMPLIANCE: undefined,
  FAIRE_POD_ORDERS_MIGRATION: true,
  FAIRE_POD_FAIRE_PAY: undefined,
  FAIRE_POD_ONE_STOP_SHOP: true,
  FAIRE_POD_MARKETS_COORDINATION: true,
  FAIRE_POD_FULFILLED_BY_FAIRE: true,
  FAIRE_POD_FULFILLMENT: undefined,
  FAIRE_POD_SEARCH_UX: true,
  FAIRE_POD_RELATIONSHIP_GROWTH: undefined,
  FAIRE_POD_RETAILER_EXPERIENCE: undefined,
  FAIRE_POD_UPMARKET_PLUS: undefined,
  FAIRE_POD_ANALYTICS_PLATFORM: undefined,
  FAIRE_POD_VALUE_PLATFORM: undefined,
  FAIRE_POD_PLATFORM_CODE_AUTHORING: undefined,
  FAIRE_POD_PLATFORM_CODE_REVIEW: undefined,
  FAIRE_POD_PLATFORM_CODE_RELEASE: undefined,
  FAIRE_POD_FINTECH_AND_OPS: undefined,
  FAIRE_POD_SEARCH_FX: undefined,
  FAIRE_POD_CLIENT_PLATFORM: true,
  FAIRE_POD_CLIENT_FOUNDATIONS: undefined,
  FAIRE_POD_MARKETING_OPERATIONS: undefined,
  FAIRE_POD_APP: undefined,
  FAIRE_POD_ORDER_REORDER: undefined,
  FAIRE_POD_OPENING_SOON: undefined,
  FAIRE_POD_ADS_SUPPLY: undefined,
  FAIRE_POD_COMPASS: undefined,
  FAIRE_POD_PREORDERS_AND_CUSTOM: undefined,
};

export const getDeprecatedForFairePod = (
  enumValue: FairePod | keyof typeof FairePod
): boolean | undefined => {
  return deprecatedForFairePod[enumValue];
};

const excludeJiraForFairePod: Partial<Record<FairePod, boolean>> = {
  FAIRE_POD_UNKNOWN: true,
  FAIRE_POD_ANTI_ABUSE: undefined,
  FAIRE_POD_APPAREL: true,
  FAIRE_POD_APPAREL_BRAND: true,
  FAIRE_POD_APPAREL_EVENTS: true,
  FAIRE_POD_APPAREL_PREORDER: true,
  FAIRE_POD_APPAREL_RETAILER: true,
  FAIRE_POD_BRAND_ACQUISITION: true,
  FAIRE_POD_BRAND_GROWTH: true,
  FAIRE_POD_BRAND_MARKETPLACE_QUALITY: true,
  FAIRE_POD_BRAND_ONBOARDING: true,
  FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM: undefined,
  FAIRE_POD_BRAND_ORDER_MANAGEMENT: true,
  FAIRE_POD_BRAND_FAIRE_DIRECT: true,
  FAIRE_POD_CATEGORY_INCUBATION: true,
  FAIRE_POD_DATA: true,
  FAIRE_POD_DISCOVERY_AI: true,
  FAIRE_POD_DISCOVERY_AE: undefined,
  FAIRE_POD_DISCOVERY_LOGGING: undefined,
  FAIRE_POD_FAIRE_FOUNDATIONS: true,
  FAIRE_POD_INTEGRATIONS: true,
  FAIRE_POD_INTERNAL_TOOLS: true,
  FAIRE_POD_INTERNATIONAL: true,
  FAIRE_POD_INTERNATIONAL_BRAND_GROWTH: true,
  FAIRE_POD_INTERNATIONAL_BRAND: true,
  FAIRE_POD_INTERNATIONAL_LAUNCH: true,
  FAIRE_POD_INTERNATIONAL_PLATFORM: true,
  FAIRE_POD_MARKETS: true,
  FAIRE_POD_RETAILER_PRICING: true,
  FAIRE_POD_SHIPPING: undefined,
  FAIRE_POD_MARKETPLACE_QUALITY: undefined,
  FAIRE_POD_MOBILE: true,
  FAIRE_POD_MOBILE_STRIKE: true,
  FAIRE_POD_MOBILE_CORE: true,
  FAIRE_POD_MOBILE_PLATFORM: true,
  FAIRE_POD_MOBILE_EXPANSION: true,
  FAIRE_POD_MOBILE_INTERNATIONAL: true,
  FAIRE_POD_MULTI_SERVICE: true,
  FAIRE_POD_PLATFORM: true,
  FAIRE_POD_PLATFORM_CONTROL: true,
  FAIRE_POD_PLATFORM_SCALE: true,
  FAIRE_POD_PLATFORM_RELIABILITY: undefined,
  FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS: undefined,
  FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCE: true,
  FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY: undefined,
  FAIRE_POD_PLATFORM_TAP: true,
  FAIRE_POD_BRAND_INFRASTRUCTURE: true,
  FAIRE_POD_PREORDERS: true,
  FAIRE_POD_PRICING: true,
  FAIRE_POD_BRAND_PRICING: true,
  FAIRE_POD_QUALITY: true,
  FAIRE_POD_RISK: true,
  FAIRE_POD_SECURITY: undefined,
  FAIRE_POD_RETAILER_LIFECYCLE: true,
  FAIRE_POD_RETAILER_CONFIDENCE: true,
  FAIRE_POD_RETAILER_GROWTH: true,
  FAIRE_POD_RETAILER_ACTIVATION: undefined,
  FAIRE_POD_RETAILER_ONBOARDING: undefined,
  FAIRE_POD_RETAILER_DISCOVERY: true,
  FAIRE_POD_INSIDER: undefined,
  FAIRE_POD_UNASSIGNED: true,
  FAIRE_POD_BRAND_UNASSIGNED: undefined,
  FAIRE_POD_WEB_PLATFORM: true,
  FAIRE_POD_CLIENT_TOOLS: true,
  FAIRE_POD_RETAILER_UNDERWRITING: true,
  FAIRE_POD_ORDER_WRITING: true,
  FAIRE_POD_LOCALIZATION: true,
  FAIRE_POD_BRAND_MARKETPLACE_SUCCESS: true,
  FAIRE_POD_STABLE_STAPLES: true,
  FAIRE_POD_FINANCIAL_PRODUCTS: true,
  FAIRE_POD_UPMARKET: true,
  FAIRE_POD_RETAILER_INSPIRE: true,
  FAIRE_POD_RETAILER_SEARCH: true,
  FAIRE_POD_RETAILER_CHECKOUT: true,
  FAIRE_POD_RETAILER_ACQUISITION: undefined,
  FAIRE_POD_RETAILER_EVALUATE: true,
  FAIRE_POD_FAIRE_DIRECT_REWARDS: true,
  FAIRE_POD_FAIRE_DIRECT_CRM: true,
  FAIRE_POD_FAIRE_DIRECT_PROSPECTING: true,
  FAIRE_POD_APPAREL_INTEGRATIONS: true,
  FAIRE_POD_BRAND_F30D_LIFECYCLE: true,
  FAIRE_POD_INTERNATIONAL_TRANSLATION: true,
  FAIRE_POD_INVOICING_AND_SUPPORT_EXPERIENCE: true,
  FAIRE_POD_VAT_INTL_CX: true,
  FAIRE_POD_INTERNATIONAL_CX: true,
  FAIRE_POD_XB_SHIPPING: true,
  FAIRE_POD_SHIPPING_EXPERIENCE: true,
  FAIRE_POD_RETAILER_INFRASTRUCTURE: true,
  FAIRE_POD_RETAILER_TAXONOMY: true,
  FAIRE_POD_FOOD_AND_BEVERAGE: true,
  FAIRE_POD_UPMARKET_GROWTH: true,
  FAIRE_POD_UPMARKET_EXPERIENCE: true,
  FAIRE_POD_FREIGHT_MARGIN: true,
  FAIRE_POD_RETAILER_REORDER: true,
  FAIRE_POD_BRAND_ENTERPRISE: true,
  FAIRE_POD_SLATE_DESIGN_SYSTEM: true,
  FAIRE_POD_DESIGN_PLATFORM: undefined,
  FAIRE_POD_SEARCH_INFRASTRUCTURE: true,
  FAIRE_POD_RETAILER_CART_SERVICE: true,
  FAIRE_POD_UPMARKET_TEAM_MANAGEMENT: true,
  FAIRE_POD_UPMARKET_TOOLING: true,
  FAIRE_POD_RETENTION_EXPERIENCE: true,
  FAIRE_POD_RETAILER_SEO: true,
  FAIRE_POD_BRAND_SERVICE_STANDARDS: true,
  FAIRE_POD_SUPPLY_INTEGRITY: true,
  FAIRE_POD_RETAILER_SUCCESS: true,
  FAIRE_POD_THEMATIC_DISCOVERY: true,
  FAIRE_POD_TAXONOMY: true,
  FAIRE_POD_SEARCH_EXPERIENCE: true,
  FAIRE_POD_INSPIRE: undefined,
  FAIRE_POD_SEARCH_RANKING_ALGORITHMS: undefined,
  FAIRE_POD_DISCOVERY_PAID_PLACEMENT: true,
  FAIRE_POD_GROWTH_MOBILE: undefined,
  FAIRE_POD_COMMUNICATIONS_PLATFORM: true,
  FAIRE_POD_OPEN_WITH_FAIRE: true,
  FAIRE_POD_COMMISSION: true,
  FAIRE_POD_FAIRE_DIRECT_GROWTH: undefined,
  FAIRE_POD_SHOPIFY: true,
  FAIRE_POD_RETAILER_POS_INTEGRATIONS: true,
  FAIRE_POD_RETAILER_TOFU: true,
  FAIRE_POD_BROWSE: true,
  FAIRE_POD_DATA_TEAM_FINANCIAL_PRODUCTS: undefined,
  FAIRE_POD_RECOMMENDATIONS: true,
  FAIRE_POD_SEARCH_EXPERIENCE_ACCELERATOR: true,
  FAIRE_POD_INTERNATIONAL_FOUNDATIONS: true,
  FAIRE_POD_SUPPORT_EXPERIENCE: true,
  FAIRE_POD_BRAND_CATALOG_COMPLETENESS: true,
  FAIRE_POD_GROWTH_PLATFORM: undefined,
  FAIRE_POD_RETAILER_ORDER_PLACEMENT: true,
  FAIRE_POD_RETAILER_ORDER_MANAGEMENT: true,
  FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT: true,
  FAIRE_POD_BRAND_PRICING_AND_REORDERS: true,
  FAIRE_POD_BRAND_CATALOG_COMPLETENESS_AND_BRAND_PROGRAMS: true,
  FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES: undefined,
  FAIRE_POD_DISCOVERY_INFRA_ENABLEMENT: undefined,
  FAIRE_POD_EXPERIMENT_PLATFORM: true,
  FAIRE_POD_KNOWLEDGE_GRAPH: undefined,
  FAIRE_POD_PLATFORM_PRODUCTIVITY: true,
  FAIRE_POD_DISCOVERY_PRODUCT_PLATFORM: undefined,
  FAIRE_POD_PERSONALIZATION: undefined,
  FAIRE_POD_BRAND_CATALOG_GROWTH: undefined,
  FAIRE_POD_SEARCH_QUERY_UNDERSTANDING_AND_RETRIEVAL: undefined,
  FAIRE_POD_CORE_DATA_INFRA: undefined,
  FAIRE_POD_PP_ADS_MANAGER: true,
  FAIRE_POD_PP_ADS_DELIVERY: true,
  FAIRE_POD_RETAILER_GROWTH_DATA_SCIENCE: undefined,
  FAIRE_POD_BRAND_DATA_SCIENCE: undefined,
  FAIRE_POD_DATA_TEAM_INSIDER_AND_SHIPPING_COSTS: undefined,
  FAIRE_POD_VALUE_MOBILE: undefined,
  FAIRE_POD_AI_PLATFORM: undefined,
  FAIRE_POD_OPS_ENABLEMENT: true,
  FAIRE_POD_EVALUATE: undefined,
  FAIRE_POD_ADS: true,
  FAIRE_POD_ADS_DELIVERY: undefined,
  FAIRE_POD_ADS_MANAGER: true,
  FAIRE_POD_ADVERTISER_GROWTH: undefined,
  FAIRE_POD_ADS_BIDDING: undefined,
  FAIRE_POD_BRAND_PLATFORM: undefined,
  FAIRE_POD_BRAND_PLATFORM_COMPLIANCE: undefined,
  FAIRE_POD_ORDERS_MIGRATION: true,
  FAIRE_POD_FAIRE_PAY: undefined,
  FAIRE_POD_ONE_STOP_SHOP: true,
  FAIRE_POD_MARKETS_COORDINATION: true,
  FAIRE_POD_FULFILLED_BY_FAIRE: true,
  FAIRE_POD_FULFILLMENT: undefined,
  FAIRE_POD_SEARCH_UX: true,
  FAIRE_POD_RELATIONSHIP_GROWTH: undefined,
  FAIRE_POD_RETAILER_EXPERIENCE: undefined,
  FAIRE_POD_UPMARKET_PLUS: undefined,
  FAIRE_POD_ANALYTICS_PLATFORM: undefined,
  FAIRE_POD_VALUE_PLATFORM: undefined,
  FAIRE_POD_PLATFORM_CODE_AUTHORING: undefined,
  FAIRE_POD_PLATFORM_CODE_REVIEW: undefined,
  FAIRE_POD_PLATFORM_CODE_RELEASE: undefined,
  FAIRE_POD_FINTECH_AND_OPS: undefined,
  FAIRE_POD_SEARCH_FX: undefined,
  FAIRE_POD_CLIENT_PLATFORM: true,
  FAIRE_POD_CLIENT_FOUNDATIONS: undefined,
  FAIRE_POD_MARKETING_OPERATIONS: undefined,
  FAIRE_POD_APP: undefined,
  FAIRE_POD_ORDER_REORDER: undefined,
  FAIRE_POD_OPENING_SOON: undefined,
  FAIRE_POD_ADS_SUPPLY: undefined,
  FAIRE_POD_COMPASS: undefined,
  FAIRE_POD_PREORDERS_AND_CUSTOM: undefined,
};

export const getExcludeJiraForFairePod = (
  enumValue: FairePod | keyof typeof FairePod
): boolean | undefined => {
  return excludeJiraForFairePod[enumValue];
};

const excludeLinearForFairePod: Partial<Record<FairePod, boolean>> = {
  FAIRE_POD_UNKNOWN: true,
  FAIRE_POD_ANTI_ABUSE: undefined,
  FAIRE_POD_APPAREL: true,
  FAIRE_POD_APPAREL_BRAND: true,
  FAIRE_POD_APPAREL_EVENTS: true,
  FAIRE_POD_APPAREL_PREORDER: true,
  FAIRE_POD_APPAREL_RETAILER: true,
  FAIRE_POD_BRAND_ACQUISITION: true,
  FAIRE_POD_BRAND_GROWTH: true,
  FAIRE_POD_BRAND_MARKETPLACE_QUALITY: true,
  FAIRE_POD_BRAND_ONBOARDING: true,
  FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM: undefined,
  FAIRE_POD_BRAND_ORDER_MANAGEMENT: true,
  FAIRE_POD_BRAND_FAIRE_DIRECT: true,
  FAIRE_POD_CATEGORY_INCUBATION: true,
  FAIRE_POD_DATA: true,
  FAIRE_POD_DISCOVERY_AI: true,
  FAIRE_POD_DISCOVERY_AE: undefined,
  FAIRE_POD_DISCOVERY_LOGGING: undefined,
  FAIRE_POD_FAIRE_FOUNDATIONS: true,
  FAIRE_POD_INTEGRATIONS: true,
  FAIRE_POD_INTERNAL_TOOLS: true,
  FAIRE_POD_INTERNATIONAL: true,
  FAIRE_POD_INTERNATIONAL_BRAND_GROWTH: true,
  FAIRE_POD_INTERNATIONAL_BRAND: true,
  FAIRE_POD_INTERNATIONAL_LAUNCH: true,
  FAIRE_POD_INTERNATIONAL_PLATFORM: true,
  FAIRE_POD_MARKETS: true,
  FAIRE_POD_RETAILER_PRICING: true,
  FAIRE_POD_SHIPPING: undefined,
  FAIRE_POD_MARKETPLACE_QUALITY: undefined,
  FAIRE_POD_MOBILE: true,
  FAIRE_POD_MOBILE_STRIKE: true,
  FAIRE_POD_MOBILE_CORE: true,
  FAIRE_POD_MOBILE_PLATFORM: true,
  FAIRE_POD_MOBILE_EXPANSION: true,
  FAIRE_POD_MOBILE_INTERNATIONAL: true,
  FAIRE_POD_MULTI_SERVICE: true,
  FAIRE_POD_PLATFORM: true,
  FAIRE_POD_PLATFORM_CONTROL: true,
  FAIRE_POD_PLATFORM_SCALE: true,
  FAIRE_POD_PLATFORM_RELIABILITY: undefined,
  FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS: undefined,
  FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCE: true,
  FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY: undefined,
  FAIRE_POD_PLATFORM_TAP: true,
  FAIRE_POD_BRAND_INFRASTRUCTURE: true,
  FAIRE_POD_PREORDERS: true,
  FAIRE_POD_PRICING: true,
  FAIRE_POD_BRAND_PRICING: true,
  FAIRE_POD_QUALITY: true,
  FAIRE_POD_RISK: true,
  FAIRE_POD_SECURITY: undefined,
  FAIRE_POD_RETAILER_LIFECYCLE: true,
  FAIRE_POD_RETAILER_CONFIDENCE: true,
  FAIRE_POD_RETAILER_GROWTH: true,
  FAIRE_POD_RETAILER_ACTIVATION: undefined,
  FAIRE_POD_RETAILER_ONBOARDING: undefined,
  FAIRE_POD_RETAILER_DISCOVERY: true,
  FAIRE_POD_INSIDER: undefined,
  FAIRE_POD_UNASSIGNED: true,
  FAIRE_POD_BRAND_UNASSIGNED: undefined,
  FAIRE_POD_WEB_PLATFORM: true,
  FAIRE_POD_CLIENT_TOOLS: true,
  FAIRE_POD_RETAILER_UNDERWRITING: true,
  FAIRE_POD_ORDER_WRITING: true,
  FAIRE_POD_LOCALIZATION: true,
  FAIRE_POD_BRAND_MARKETPLACE_SUCCESS: true,
  FAIRE_POD_STABLE_STAPLES: true,
  FAIRE_POD_FINANCIAL_PRODUCTS: true,
  FAIRE_POD_UPMARKET: true,
  FAIRE_POD_RETAILER_INSPIRE: true,
  FAIRE_POD_RETAILER_SEARCH: true,
  FAIRE_POD_RETAILER_CHECKOUT: true,
  FAIRE_POD_RETAILER_ACQUISITION: undefined,
  FAIRE_POD_RETAILER_EVALUATE: true,
  FAIRE_POD_FAIRE_DIRECT_REWARDS: true,
  FAIRE_POD_FAIRE_DIRECT_CRM: true,
  FAIRE_POD_FAIRE_DIRECT_PROSPECTING: true,
  FAIRE_POD_APPAREL_INTEGRATIONS: true,
  FAIRE_POD_BRAND_F30D_LIFECYCLE: true,
  FAIRE_POD_INTERNATIONAL_TRANSLATION: true,
  FAIRE_POD_INVOICING_AND_SUPPORT_EXPERIENCE: true,
  FAIRE_POD_VAT_INTL_CX: true,
  FAIRE_POD_INTERNATIONAL_CX: true,
  FAIRE_POD_XB_SHIPPING: true,
  FAIRE_POD_SHIPPING_EXPERIENCE: true,
  FAIRE_POD_RETAILER_INFRASTRUCTURE: true,
  FAIRE_POD_RETAILER_TAXONOMY: true,
  FAIRE_POD_FOOD_AND_BEVERAGE: true,
  FAIRE_POD_UPMARKET_GROWTH: true,
  FAIRE_POD_UPMARKET_EXPERIENCE: true,
  FAIRE_POD_FREIGHT_MARGIN: true,
  FAIRE_POD_RETAILER_REORDER: true,
  FAIRE_POD_BRAND_ENTERPRISE: true,
  FAIRE_POD_SLATE_DESIGN_SYSTEM: true,
  FAIRE_POD_DESIGN_PLATFORM: undefined,
  FAIRE_POD_SEARCH_INFRASTRUCTURE: true,
  FAIRE_POD_RETAILER_CART_SERVICE: true,
  FAIRE_POD_UPMARKET_TEAM_MANAGEMENT: true,
  FAIRE_POD_UPMARKET_TOOLING: true,
  FAIRE_POD_RETENTION_EXPERIENCE: true,
  FAIRE_POD_RETAILER_SEO: true,
  FAIRE_POD_BRAND_SERVICE_STANDARDS: true,
  FAIRE_POD_SUPPLY_INTEGRITY: true,
  FAIRE_POD_RETAILER_SUCCESS: true,
  FAIRE_POD_THEMATIC_DISCOVERY: true,
  FAIRE_POD_TAXONOMY: true,
  FAIRE_POD_SEARCH_EXPERIENCE: true,
  FAIRE_POD_INSPIRE: undefined,
  FAIRE_POD_SEARCH_RANKING_ALGORITHMS: undefined,
  FAIRE_POD_DISCOVERY_PAID_PLACEMENT: true,
  FAIRE_POD_GROWTH_MOBILE: undefined,
  FAIRE_POD_COMMUNICATIONS_PLATFORM: true,
  FAIRE_POD_OPEN_WITH_FAIRE: true,
  FAIRE_POD_COMMISSION: true,
  FAIRE_POD_FAIRE_DIRECT_GROWTH: undefined,
  FAIRE_POD_SHOPIFY: true,
  FAIRE_POD_RETAILER_POS_INTEGRATIONS: true,
  FAIRE_POD_RETAILER_TOFU: true,
  FAIRE_POD_BROWSE: true,
  FAIRE_POD_DATA_TEAM_FINANCIAL_PRODUCTS: undefined,
  FAIRE_POD_RECOMMENDATIONS: true,
  FAIRE_POD_SEARCH_EXPERIENCE_ACCELERATOR: true,
  FAIRE_POD_INTERNATIONAL_FOUNDATIONS: true,
  FAIRE_POD_SUPPORT_EXPERIENCE: true,
  FAIRE_POD_BRAND_CATALOG_COMPLETENESS: true,
  FAIRE_POD_GROWTH_PLATFORM: undefined,
  FAIRE_POD_RETAILER_ORDER_PLACEMENT: true,
  FAIRE_POD_RETAILER_ORDER_MANAGEMENT: true,
  FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT: true,
  FAIRE_POD_BRAND_PRICING_AND_REORDERS: true,
  FAIRE_POD_BRAND_CATALOG_COMPLETENESS_AND_BRAND_PROGRAMS: true,
  FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES: undefined,
  FAIRE_POD_DISCOVERY_INFRA_ENABLEMENT: undefined,
  FAIRE_POD_EXPERIMENT_PLATFORM: true,
  FAIRE_POD_KNOWLEDGE_GRAPH: undefined,
  FAIRE_POD_PLATFORM_PRODUCTIVITY: true,
  FAIRE_POD_DISCOVERY_PRODUCT_PLATFORM: undefined,
  FAIRE_POD_PERSONALIZATION: undefined,
  FAIRE_POD_BRAND_CATALOG_GROWTH: undefined,
  FAIRE_POD_SEARCH_QUERY_UNDERSTANDING_AND_RETRIEVAL: undefined,
  FAIRE_POD_CORE_DATA_INFRA: undefined,
  FAIRE_POD_PP_ADS_MANAGER: true,
  FAIRE_POD_PP_ADS_DELIVERY: true,
  FAIRE_POD_RETAILER_GROWTH_DATA_SCIENCE: undefined,
  FAIRE_POD_BRAND_DATA_SCIENCE: undefined,
  FAIRE_POD_DATA_TEAM_INSIDER_AND_SHIPPING_COSTS: undefined,
  FAIRE_POD_VALUE_MOBILE: undefined,
  FAIRE_POD_AI_PLATFORM: undefined,
  FAIRE_POD_OPS_ENABLEMENT: true,
  FAIRE_POD_EVALUATE: undefined,
  FAIRE_POD_ADS: true,
  FAIRE_POD_ADS_DELIVERY: undefined,
  FAIRE_POD_ADS_MANAGER: true,
  FAIRE_POD_ADVERTISER_GROWTH: undefined,
  FAIRE_POD_ADS_BIDDING: undefined,
  FAIRE_POD_BRAND_PLATFORM: undefined,
  FAIRE_POD_BRAND_PLATFORM_COMPLIANCE: undefined,
  FAIRE_POD_ORDERS_MIGRATION: true,
  FAIRE_POD_FAIRE_PAY: undefined,
  FAIRE_POD_ONE_STOP_SHOP: true,
  FAIRE_POD_MARKETS_COORDINATION: true,
  FAIRE_POD_FULFILLED_BY_FAIRE: true,
  FAIRE_POD_FULFILLMENT: undefined,
  FAIRE_POD_SEARCH_UX: true,
  FAIRE_POD_RELATIONSHIP_GROWTH: undefined,
  FAIRE_POD_RETAILER_EXPERIENCE: undefined,
  FAIRE_POD_UPMARKET_PLUS: undefined,
  FAIRE_POD_ANALYTICS_PLATFORM: undefined,
  FAIRE_POD_VALUE_PLATFORM: undefined,
  FAIRE_POD_PLATFORM_CODE_AUTHORING: undefined,
  FAIRE_POD_PLATFORM_CODE_REVIEW: undefined,
  FAIRE_POD_PLATFORM_CODE_RELEASE: undefined,
  FAIRE_POD_FINTECH_AND_OPS: undefined,
  FAIRE_POD_SEARCH_FX: undefined,
  FAIRE_POD_CLIENT_PLATFORM: true,
  FAIRE_POD_CLIENT_FOUNDATIONS: undefined,
  FAIRE_POD_MARKETING_OPERATIONS: undefined,
  FAIRE_POD_APP: undefined,
  FAIRE_POD_ORDER_REORDER: undefined,
  FAIRE_POD_OPENING_SOON: undefined,
  FAIRE_POD_ADS_SUPPLY: undefined,
  FAIRE_POD_COMPASS: undefined,
  FAIRE_POD_PREORDERS_AND_CUSTOM: undefined,
};

export const getExcludeLinearForFairePod = (
  enumValue: FairePod | keyof typeof FairePod
): boolean | undefined => {
  return excludeLinearForFairePod[enumValue];
};

const pillarForFairePod: Partial<Record<FairePod, keyof typeof FairePillar>> = {
  FAIRE_POD_UNKNOWN: undefined,
  FAIRE_POD_ANTI_ABUSE: `FAIRE_PILLAR_EPDD_FOUNDATIONS`,
  FAIRE_POD_APPAREL: undefined,
  FAIRE_POD_APPAREL_BRAND: undefined,
  FAIRE_POD_APPAREL_EVENTS: undefined,
  FAIRE_POD_APPAREL_PREORDER: undefined,
  FAIRE_POD_APPAREL_RETAILER: undefined,
  FAIRE_POD_BRAND_ACQUISITION: `FAIRE_PILLAR_BRAND`,
  FAIRE_POD_BRAND_GROWTH: undefined,
  FAIRE_POD_BRAND_MARKETPLACE_QUALITY: undefined,
  FAIRE_POD_BRAND_ONBOARDING: `FAIRE_PILLAR_BRAND`,
  FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM: `FAIRE_PILLAR_BRAND`,
  FAIRE_POD_BRAND_ORDER_MANAGEMENT: `FAIRE_PILLAR_BRAND`,
  FAIRE_POD_BRAND_FAIRE_DIRECT: undefined,
  FAIRE_POD_CATEGORY_INCUBATION: undefined,
  FAIRE_POD_DATA: `FAIRE_PILLAR_DATA`,
  FAIRE_POD_DISCOVERY_AI: `FAIRE_PILLAR_DISCOVERY`,
  FAIRE_POD_DISCOVERY_AE: `FAIRE_PILLAR_DISCOVERY`,
  FAIRE_POD_DISCOVERY_LOGGING: `FAIRE_PILLAR_DISCOVERY`,
  FAIRE_POD_FAIRE_FOUNDATIONS: `FAIRE_PILLAR_PLATFORM`,
  FAIRE_POD_INTEGRATIONS: `FAIRE_PILLAR_BRAND`,
  FAIRE_POD_INTERNAL_TOOLS: `FAIRE_PILLAR_PLATFORM`,
  FAIRE_POD_INTERNATIONAL: undefined,
  FAIRE_POD_INTERNATIONAL_BRAND_GROWTH: undefined,
  FAIRE_POD_INTERNATIONAL_BRAND: `FAIRE_PILLAR_INTERNATIONAL`,
  FAIRE_POD_INTERNATIONAL_LAUNCH: undefined,
  FAIRE_POD_INTERNATIONAL_PLATFORM: `FAIRE_PILLAR_INTERNATIONAL`,
  FAIRE_POD_MARKETS: `FAIRE_PILLAR_RETAILER`,
  FAIRE_POD_RETAILER_PRICING: `FAIRE_PILLAR_RETAILER_TOOLS_AND_PROGRAMS`,
  FAIRE_POD_SHIPPING: `FAIRE_PILLAR_VALUE`,
  FAIRE_POD_MARKETPLACE_QUALITY: `FAIRE_PILLAR_BRAND`,
  FAIRE_POD_MOBILE: undefined,
  FAIRE_POD_MOBILE_STRIKE: `FAIRE_PILLAR_DISCOVERY`,
  FAIRE_POD_MOBILE_CORE: `FAIRE_PILLAR_RETAILER`,
  FAIRE_POD_MOBILE_PLATFORM: `FAIRE_PILLAR_EPDD_FOUNDATIONS`,
  FAIRE_POD_MOBILE_EXPANSION: undefined,
  FAIRE_POD_MOBILE_INTERNATIONAL: `FAIRE_PILLAR_INTERNATIONAL`,
  FAIRE_POD_MULTI_SERVICE: undefined,
  FAIRE_POD_PLATFORM: `FAIRE_PILLAR_PLATFORM`,
  FAIRE_POD_PLATFORM_CONTROL: `FAIRE_PILLAR_EPDD_FOUNDATIONS`,
  FAIRE_POD_PLATFORM_SCALE: `FAIRE_PILLAR_EPDD_FOUNDATIONS`,
  FAIRE_POD_PLATFORM_RELIABILITY: `FAIRE_PILLAR_EPDD_FOUNDATIONS`,
  FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS: `FAIRE_PILLAR_EPDD_FOUNDATIONS`,
  FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCE: `FAIRE_PILLAR_EPDD_FOUNDATIONS`,
  FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY: `FAIRE_PILLAR_EPDD_FOUNDATIONS`,
  FAIRE_POD_PLATFORM_TAP: undefined,
  FAIRE_POD_BRAND_INFRASTRUCTURE: `FAIRE_PILLAR_BRAND`,
  FAIRE_POD_PREORDERS: undefined,
  FAIRE_POD_PRICING: `FAIRE_PILLAR_BRAND`,
  FAIRE_POD_BRAND_PRICING: `FAIRE_PILLAR_BRAND`,
  FAIRE_POD_QUALITY: `FAIRE_PILLAR_EPDD_FOUNDATIONS`,
  FAIRE_POD_RISK: undefined,
  FAIRE_POD_SECURITY: `FAIRE_PILLAR_EPDD_FOUNDATIONS`,
  FAIRE_POD_RETAILER_LIFECYCLE: undefined,
  FAIRE_POD_RETAILER_CONFIDENCE: undefined,
  FAIRE_POD_RETAILER_GROWTH: `FAIRE_PILLAR_RETAILER_GROWTH`,
  FAIRE_POD_RETAILER_ACTIVATION: `FAIRE_PILLAR_RETAILER_GROWTH`,
  FAIRE_POD_RETAILER_ONBOARDING: `FAIRE_PILLAR_RETAILER_GROWTH`,
  FAIRE_POD_RETAILER_DISCOVERY: undefined,
  FAIRE_POD_INSIDER: `FAIRE_PILLAR_VALUE`,
  FAIRE_POD_UNASSIGNED: `FAIRE_PILLAR_UNASSIGNED`,
  FAIRE_POD_BRAND_UNASSIGNED: `FAIRE_PILLAR_BRAND`,
  FAIRE_POD_WEB_PLATFORM: `FAIRE_PILLAR_EPDD_FOUNDATIONS`,
  FAIRE_POD_CLIENT_TOOLS: undefined,
  FAIRE_POD_RETAILER_UNDERWRITING: undefined,
  FAIRE_POD_ORDER_WRITING: undefined,
  FAIRE_POD_LOCALIZATION: undefined,
  FAIRE_POD_BRAND_MARKETPLACE_SUCCESS: undefined,
  FAIRE_POD_STABLE_STAPLES: undefined,
  FAIRE_POD_FINANCIAL_PRODUCTS: `FAIRE_PILLAR_VALUE`,
  FAIRE_POD_UPMARKET: undefined,
  FAIRE_POD_RETAILER_INSPIRE: `FAIRE_PILLAR_RETAILER`,
  FAIRE_POD_RETAILER_SEARCH: `FAIRE_PILLAR_DISCOVERY`,
  FAIRE_POD_RETAILER_CHECKOUT: undefined,
  FAIRE_POD_RETAILER_ACQUISITION: `FAIRE_PILLAR_RETAILER_GROWTH`,
  FAIRE_POD_RETAILER_EVALUATE: `FAIRE_PILLAR_RETAILER`,
  FAIRE_POD_FAIRE_DIRECT_REWARDS: undefined,
  FAIRE_POD_FAIRE_DIRECT_CRM: `FAIRE_PILLAR_BRAND`,
  FAIRE_POD_FAIRE_DIRECT_PROSPECTING: `FAIRE_PILLAR_BRAND`,
  FAIRE_POD_APPAREL_INTEGRATIONS: `FAIRE_PILLAR_EXPANSION`,
  FAIRE_POD_BRAND_F30D_LIFECYCLE: `FAIRE_PILLAR_BRAND`,
  FAIRE_POD_INTERNATIONAL_TRANSLATION: `FAIRE_PILLAR_INTERNATIONAL`,
  FAIRE_POD_INVOICING_AND_SUPPORT_EXPERIENCE: `FAIRE_PILLAR_INTERNATIONAL`,
  FAIRE_POD_VAT_INTL_CX: undefined,
  FAIRE_POD_INTERNATIONAL_CX: undefined,
  FAIRE_POD_XB_SHIPPING: undefined,
  FAIRE_POD_SHIPPING_EXPERIENCE: `FAIRE_PILLAR_BRAND`,
  FAIRE_POD_RETAILER_INFRASTRUCTURE: undefined,
  FAIRE_POD_RETAILER_TAXONOMY: `FAIRE_PILLAR_DISCOVERY`,
  FAIRE_POD_FOOD_AND_BEVERAGE: `FAIRE_PILLAR_DISCOVERY`,
  FAIRE_POD_UPMARKET_GROWTH: undefined,
  FAIRE_POD_UPMARKET_EXPERIENCE: `FAIRE_PILLAR_EXPANSION`,
  FAIRE_POD_FREIGHT_MARGIN: `FAIRE_PILLAR_INTERNATIONAL`,
  FAIRE_POD_RETAILER_REORDER: undefined,
  FAIRE_POD_BRAND_ENTERPRISE: `FAIRE_PILLAR_BRAND`,
  FAIRE_POD_SLATE_DESIGN_SYSTEM: `FAIRE_PILLAR_EPDD_FOUNDATIONS`,
  FAIRE_POD_DESIGN_PLATFORM: `FAIRE_PILLAR_EPDD_FOUNDATIONS`,
  FAIRE_POD_SEARCH_INFRASTRUCTURE: `FAIRE_PILLAR_DISCOVERY`,
  FAIRE_POD_RETAILER_CART_SERVICE: undefined,
  FAIRE_POD_UPMARKET_TEAM_MANAGEMENT: `FAIRE_PILLAR_RETAILER`,
  FAIRE_POD_UPMARKET_TOOLING: `FAIRE_PILLAR_RETAILER_TOOLS_AND_PROGRAMS`,
  FAIRE_POD_RETENTION_EXPERIENCE: undefined,
  FAIRE_POD_RETAILER_SEO: undefined,
  FAIRE_POD_BRAND_SERVICE_STANDARDS: `FAIRE_PILLAR_BRAND`,
  FAIRE_POD_SUPPLY_INTEGRITY: `FAIRE_PILLAR_BRAND`,
  FAIRE_POD_RETAILER_SUCCESS: `FAIRE_PILLAR_RETAILER`,
  FAIRE_POD_THEMATIC_DISCOVERY: undefined,
  FAIRE_POD_TAXONOMY: `FAIRE_PILLAR_DISCOVERY`,
  FAIRE_POD_SEARCH_EXPERIENCE: `FAIRE_PILLAR_DISCOVERY`,
  FAIRE_POD_INSPIRE: `FAIRE_PILLAR_DISCOVERY`,
  FAIRE_POD_SEARCH_RANKING_ALGORITHMS: `FAIRE_PILLAR_DISCOVERY`,
  FAIRE_POD_DISCOVERY_PAID_PLACEMENT: `FAIRE_PILLAR_DISCOVERY`,
  FAIRE_POD_GROWTH_MOBILE: `FAIRE_PILLAR_RETAILER_GROWTH`,
  FAIRE_POD_COMMUNICATIONS_PLATFORM: undefined,
  FAIRE_POD_OPEN_WITH_FAIRE: `FAIRE_PILLAR_RETAILER_GROWTH`,
  FAIRE_POD_COMMISSION: `FAIRE_PILLAR_BRAND`,
  FAIRE_POD_FAIRE_DIRECT_GROWTH: `FAIRE_PILLAR_RETAILER_GROWTH`,
  FAIRE_POD_SHOPIFY: `FAIRE_PILLAR_BRAND`,
  FAIRE_POD_RETAILER_POS_INTEGRATIONS: `FAIRE_PILLAR_RETAILER`,
  FAIRE_POD_RETAILER_TOFU: `FAIRE_PILLAR_RETAILER_GROWTH`,
  FAIRE_POD_BROWSE: `FAIRE_PILLAR_DISCOVERY`,
  FAIRE_POD_DATA_TEAM_FINANCIAL_PRODUCTS: `FAIRE_PILLAR_VALUE`,
  FAIRE_POD_RECOMMENDATIONS: `FAIRE_PILLAR_DISCOVERY`,
  FAIRE_POD_SEARCH_EXPERIENCE_ACCELERATOR: `FAIRE_PILLAR_DISCOVERY`,
  FAIRE_POD_INTERNATIONAL_FOUNDATIONS: `FAIRE_PILLAR_BRAND`,
  FAIRE_POD_SUPPORT_EXPERIENCE: `FAIRE_PILLAR_RETAILER_TOOLS_AND_PROGRAMS`,
  FAIRE_POD_BRAND_CATALOG_COMPLETENESS: `FAIRE_PILLAR_BRAND`,
  FAIRE_POD_GROWTH_PLATFORM: `FAIRE_PILLAR_RETAILER_GROWTH`,
  FAIRE_POD_RETAILER_ORDER_PLACEMENT: `FAIRE_PILLAR_VALUE`,
  FAIRE_POD_RETAILER_ORDER_MANAGEMENT: `FAIRE_PILLAR_RETAILER_TOOLS_AND_PROGRAMS`,
  FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT: `FAIRE_PILLAR_BRAND`,
  FAIRE_POD_BRAND_PRICING_AND_REORDERS: `FAIRE_PILLAR_BRAND`,
  FAIRE_POD_BRAND_CATALOG_COMPLETENESS_AND_BRAND_PROGRAMS: `FAIRE_PILLAR_BRAND`,
  FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES: `FAIRE_PILLAR_BRAND`,
  FAIRE_POD_DISCOVERY_INFRA_ENABLEMENT: `FAIRE_PILLAR_DISCOVERY`,
  FAIRE_POD_EXPERIMENT_PLATFORM: `FAIRE_PILLAR_EPDD_FOUNDATIONS`,
  FAIRE_POD_KNOWLEDGE_GRAPH: `FAIRE_PILLAR_EPDD_FOUNDATIONS`,
  FAIRE_POD_PLATFORM_PRODUCTIVITY: `FAIRE_PILLAR_EPDD_FOUNDATIONS`,
  FAIRE_POD_DISCOVERY_PRODUCT_PLATFORM: `FAIRE_PILLAR_DISCOVERY`,
  FAIRE_POD_PERSONALIZATION: `FAIRE_PILLAR_DISCOVERY`,
  FAIRE_POD_BRAND_CATALOG_GROWTH: `FAIRE_PILLAR_BRAND`,
  FAIRE_POD_SEARCH_QUERY_UNDERSTANDING_AND_RETRIEVAL: `FAIRE_PILLAR_DISCOVERY`,
  FAIRE_POD_CORE_DATA_INFRA: `FAIRE_PILLAR_EPDD_FOUNDATIONS`,
  FAIRE_POD_PP_ADS_MANAGER: `FAIRE_PILLAR_DISCOVERY`,
  FAIRE_POD_PP_ADS_DELIVERY: `FAIRE_PILLAR_DISCOVERY`,
  FAIRE_POD_RETAILER_GROWTH_DATA_SCIENCE: `FAIRE_PILLAR_RETAILER_GROWTH`,
  FAIRE_POD_BRAND_DATA_SCIENCE: `FAIRE_PILLAR_BRAND`,
  FAIRE_POD_DATA_TEAM_INSIDER_AND_SHIPPING_COSTS: `FAIRE_PILLAR_VALUE`,
  FAIRE_POD_VALUE_MOBILE: `FAIRE_PILLAR_VALUE`,
  FAIRE_POD_AI_PLATFORM: `FAIRE_PILLAR_EPDD_FOUNDATIONS`,
  FAIRE_POD_OPS_ENABLEMENT: `FAIRE_PILLAR_VALUE`,
  FAIRE_POD_EVALUATE: `FAIRE_PILLAR_DISCOVERY`,
  FAIRE_POD_ADS: `FAIRE_PILLAR_DISCOVERY`,
  FAIRE_POD_ADS_DELIVERY: `FAIRE_PILLAR_ADS`,
  FAIRE_POD_ADS_MANAGER: `FAIRE_PILLAR_DISCOVERY`,
  FAIRE_POD_ADVERTISER_GROWTH: `FAIRE_PILLAR_ADS`,
  FAIRE_POD_ADS_BIDDING: `FAIRE_PILLAR_ADS`,
  FAIRE_POD_BRAND_PLATFORM: `FAIRE_PILLAR_BRAND`,
  FAIRE_POD_BRAND_PLATFORM_COMPLIANCE: `FAIRE_PILLAR_BRAND`,
  FAIRE_POD_ORDERS_MIGRATION: `FAIRE_PILLAR_VALUE`,
  FAIRE_POD_FAIRE_PAY: `FAIRE_PILLAR_VALUE`,
  FAIRE_POD_ONE_STOP_SHOP: `FAIRE_PILLAR_VALUE`,
  FAIRE_POD_MARKETS_COORDINATION: `FAIRE_PILLAR_VALUE`,
  FAIRE_POD_FULFILLED_BY_FAIRE: `FAIRE_PILLAR_VALUE`,
  FAIRE_POD_FULFILLMENT: `FAIRE_PILLAR_VALUE`,
  FAIRE_POD_SEARCH_UX: `FAIRE_PILLAR_DISCOVERY`,
  FAIRE_POD_RELATIONSHIP_GROWTH: `FAIRE_PILLAR_RETAILER_GROWTH`,
  FAIRE_POD_RETAILER_EXPERIENCE: `FAIRE_PILLAR_DISCOVERY`,
  FAIRE_POD_UPMARKET_PLUS: `FAIRE_PILLAR_RETAILER_GROWTH`,
  FAIRE_POD_ANALYTICS_PLATFORM: `FAIRE_PILLAR_EPDD_FOUNDATIONS`,
  FAIRE_POD_VALUE_PLATFORM: `FAIRE_PILLAR_VALUE`,
  FAIRE_POD_PLATFORM_CODE_AUTHORING: `FAIRE_PILLAR_EPDD_FOUNDATIONS`,
  FAIRE_POD_PLATFORM_CODE_REVIEW: `FAIRE_PILLAR_EPDD_FOUNDATIONS`,
  FAIRE_POD_PLATFORM_CODE_RELEASE: `FAIRE_PILLAR_EPDD_FOUNDATIONS`,
  FAIRE_POD_FINTECH_AND_OPS: `FAIRE_PILLAR_VALUE`,
  FAIRE_POD_SEARCH_FX: `FAIRE_PILLAR_DISCOVERY`,
  FAIRE_POD_CLIENT_PLATFORM: `FAIRE_PILLAR_EPDD_FOUNDATIONS`,
  FAIRE_POD_CLIENT_FOUNDATIONS: `FAIRE_PILLAR_EPDD_FOUNDATIONS`,
  FAIRE_POD_MARKETING_OPERATIONS: `FAIRE_PILLAR_RETAILER_GROWTH`,
  FAIRE_POD_APP: `FAIRE_PILLAR_DISCOVERY`,
  FAIRE_POD_ORDER_REORDER: `FAIRE_PILLAR_DISCOVERY`,
  FAIRE_POD_OPENING_SOON: `FAIRE_PILLAR_RETAILER_GROWTH`,
  FAIRE_POD_ADS_SUPPLY: `FAIRE_PILLAR_ADS`,
  FAIRE_POD_COMPASS: `FAIRE_PILLAR_DISCOVERY`,
  FAIRE_POD_PREORDERS_AND_CUSTOM: `FAIRE_PILLAR_BRAND`,
};

export const getPillarForFairePod = (
  enumValue: FairePod | keyof typeof FairePod
): keyof typeof FairePillar | undefined => {
  return pillarForFairePod[enumValue];
};

const oncallForFairePod: Partial<Record<FairePod, keyof typeof FaireOncall>> = {
  FAIRE_POD_UNKNOWN: undefined,
  FAIRE_POD_ANTI_ABUSE: `FAIRE_ONCALL_ANTI_ABUSE`,
  FAIRE_POD_APPAREL: undefined,
  FAIRE_POD_APPAREL_BRAND: undefined,
  FAIRE_POD_APPAREL_EVENTS: undefined,
  FAIRE_POD_APPAREL_PREORDER: undefined,
  FAIRE_POD_APPAREL_RETAILER: undefined,
  FAIRE_POD_BRAND_ACQUISITION: `FAIRE_ONCALL_BRAND`,
  FAIRE_POD_BRAND_GROWTH: undefined,
  FAIRE_POD_BRAND_MARKETPLACE_QUALITY: undefined,
  FAIRE_POD_BRAND_ONBOARDING: undefined,
  FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM: `FAIRE_ONCALL_BRAND`,
  FAIRE_POD_BRAND_ORDER_MANAGEMENT: undefined,
  FAIRE_POD_BRAND_FAIRE_DIRECT: undefined,
  FAIRE_POD_CATEGORY_INCUBATION: undefined,
  FAIRE_POD_DATA: undefined,
  FAIRE_POD_DISCOVERY_AI: `FAIRE_ONCALL_DISCOVERY`,
  FAIRE_POD_DISCOVERY_AE: `FAIRE_ONCALL_DISCOVERY`,
  FAIRE_POD_DISCOVERY_LOGGING: `FAIRE_ONCALL_DISCOVERY`,
  FAIRE_POD_FAIRE_FOUNDATIONS: undefined,
  FAIRE_POD_INTEGRATIONS: undefined,
  FAIRE_POD_INTERNAL_TOOLS: undefined,
  FAIRE_POD_INTERNATIONAL: undefined,
  FAIRE_POD_INTERNATIONAL_BRAND_GROWTH: undefined,
  FAIRE_POD_INTERNATIONAL_BRAND: undefined,
  FAIRE_POD_INTERNATIONAL_LAUNCH: undefined,
  FAIRE_POD_INTERNATIONAL_PLATFORM: undefined,
  FAIRE_POD_MARKETS: `FAIRE_ONCALL_RETAILER_ORDER_INCENTIVES`,
  FAIRE_POD_RETAILER_PRICING: `FAIRE_ONCALL_RETAILER_TOOLS_AND_PROGRAMS`,
  FAIRE_POD_SHIPPING: `FAIRE_ONCALL_VALUE`,
  FAIRE_POD_MARKETPLACE_QUALITY: `FAIRE_ONCALL_BRAND`,
  FAIRE_POD_MOBILE: undefined,
  FAIRE_POD_MOBILE_STRIKE: `FAIRE_ONCALL_DISCOVERY`,
  FAIRE_POD_MOBILE_CORE: undefined,
  FAIRE_POD_MOBILE_PLATFORM: undefined,
  FAIRE_POD_MOBILE_EXPANSION: undefined,
  FAIRE_POD_MOBILE_INTERNATIONAL: `FAIRE_ONCALL_INTERNATIONAL`,
  FAIRE_POD_MULTI_SERVICE: undefined,
  FAIRE_POD_PLATFORM: undefined,
  FAIRE_POD_PLATFORM_CONTROL: `FAIRE_ONCALL_PLATFORM`,
  FAIRE_POD_PLATFORM_SCALE: `FAIRE_ONCALL_PLATFORM`,
  FAIRE_POD_PLATFORM_RELIABILITY: `FAIRE_ONCALL_PLATFORM`,
  FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS: `FAIRE_ONCALL_PLATFORM`,
  FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCE: `FAIRE_ONCALL_PLATFORM`,
  FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY: `FAIRE_ONCALL_PLATFORM`,
  FAIRE_POD_PLATFORM_TAP: undefined,
  FAIRE_POD_BRAND_INFRASTRUCTURE: `FAIRE_ONCALL_BRAND`,
  FAIRE_POD_PREORDERS: undefined,
  FAIRE_POD_PRICING: `FAIRE_ONCALL_BRAND`,
  FAIRE_POD_BRAND_PRICING: undefined,
  FAIRE_POD_QUALITY: `FAIRE_ONCALL_PLATFORM`,
  FAIRE_POD_RISK: undefined,
  FAIRE_POD_SECURITY: `FAIRE_ONCALL_SECURITY`,
  FAIRE_POD_RETAILER_LIFECYCLE: undefined,
  FAIRE_POD_RETAILER_CONFIDENCE: undefined,
  FAIRE_POD_RETAILER_GROWTH: undefined,
  FAIRE_POD_RETAILER_ACTIVATION: `FAIRE_ONCALL_RETAILER_GROWTH`,
  FAIRE_POD_RETAILER_ONBOARDING: `FAIRE_ONCALL_RETAILER_GROWTH`,
  FAIRE_POD_RETAILER_DISCOVERY: undefined,
  FAIRE_POD_INSIDER: `FAIRE_ONCALL_VALUE`,
  FAIRE_POD_UNASSIGNED: `FAIRE_ONCALL_UNASSIGNED`,
  FAIRE_POD_BRAND_UNASSIGNED: `FAIRE_ONCALL_BRAND`,
  FAIRE_POD_WEB_PLATFORM: undefined,
  FAIRE_POD_CLIENT_TOOLS: undefined,
  FAIRE_POD_RETAILER_UNDERWRITING: undefined,
  FAIRE_POD_ORDER_WRITING: undefined,
  FAIRE_POD_LOCALIZATION: undefined,
  FAIRE_POD_BRAND_MARKETPLACE_SUCCESS: undefined,
  FAIRE_POD_STABLE_STAPLES: undefined,
  FAIRE_POD_FINANCIAL_PRODUCTS: `FAIRE_ONCALL_VALUE`,
  FAIRE_POD_UPMARKET: undefined,
  FAIRE_POD_RETAILER_INSPIRE: undefined,
  FAIRE_POD_RETAILER_SEARCH: undefined,
  FAIRE_POD_RETAILER_CHECKOUT: undefined,
  FAIRE_POD_RETAILER_ACQUISITION: `FAIRE_ONCALL_RETAILER_GROWTH`,
  FAIRE_POD_RETAILER_EVALUATE: `FAIRE_ONCALL_RETAILER_ORDER_INCENTIVES`,
  FAIRE_POD_FAIRE_DIRECT_REWARDS: undefined,
  FAIRE_POD_FAIRE_DIRECT_CRM: undefined,
  FAIRE_POD_FAIRE_DIRECT_PROSPECTING: undefined,
  FAIRE_POD_APPAREL_INTEGRATIONS: undefined,
  FAIRE_POD_BRAND_F30D_LIFECYCLE: undefined,
  FAIRE_POD_INTERNATIONAL_TRANSLATION: `FAIRE_ONCALL_INTERNATIONAL`,
  FAIRE_POD_INVOICING_AND_SUPPORT_EXPERIENCE: `FAIRE_ONCALL_INTERNATIONAL`,
  FAIRE_POD_VAT_INTL_CX: undefined,
  FAIRE_POD_INTERNATIONAL_CX: undefined,
  FAIRE_POD_XB_SHIPPING: undefined,
  FAIRE_POD_SHIPPING_EXPERIENCE: undefined,
  FAIRE_POD_RETAILER_INFRASTRUCTURE: undefined,
  FAIRE_POD_RETAILER_TAXONOMY: undefined,
  FAIRE_POD_FOOD_AND_BEVERAGE: `FAIRE_ONCALL_DISCOVERY`,
  FAIRE_POD_UPMARKET_GROWTH: undefined,
  FAIRE_POD_UPMARKET_EXPERIENCE: undefined,
  FAIRE_POD_FREIGHT_MARGIN: undefined,
  FAIRE_POD_RETAILER_REORDER: undefined,
  FAIRE_POD_BRAND_ENTERPRISE: undefined,
  FAIRE_POD_SLATE_DESIGN_SYSTEM: undefined,
  FAIRE_POD_DESIGN_PLATFORM: `FAIRE_ONCALL_PLATFORM`,
  FAIRE_POD_SEARCH_INFRASTRUCTURE: `FAIRE_ONCALL_DISCOVERY_INFRA_AND_ENABLEMENT`,
  FAIRE_POD_RETAILER_CART_SERVICE: undefined,
  FAIRE_POD_UPMARKET_TEAM_MANAGEMENT: `FAIRE_ONCALL_RETAILER_ORDER_INCENTIVES`,
  FAIRE_POD_UPMARKET_TOOLING: `FAIRE_ONCALL_RETAILER_TOOLS_AND_PROGRAMS`,
  FAIRE_POD_RETENTION_EXPERIENCE: undefined,
  FAIRE_POD_RETAILER_SEO: undefined,
  FAIRE_POD_BRAND_SERVICE_STANDARDS: undefined,
  FAIRE_POD_SUPPLY_INTEGRITY: undefined,
  FAIRE_POD_RETAILER_SUCCESS: `FAIRE_ONCALL_RETAILER_ORDER_INCENTIVES`,
  FAIRE_POD_THEMATIC_DISCOVERY: undefined,
  FAIRE_POD_TAXONOMY: `FAIRE_ONCALL_DISCOVERY`,
  FAIRE_POD_SEARCH_EXPERIENCE: `FAIRE_ONCALL_DISCOVERY_INFRA_AND_ENABLEMENT`,
  FAIRE_POD_INSPIRE: `FAIRE_ONCALL_DISCOVERY`,
  FAIRE_POD_SEARCH_RANKING_ALGORITHMS: `FAIRE_ONCALL_DISCOVERY_INFRA_AND_ENABLEMENT`,
  FAIRE_POD_DISCOVERY_PAID_PLACEMENT: `FAIRE_ONCALL_ADS`,
  FAIRE_POD_GROWTH_MOBILE: `FAIRE_ONCALL_RETAILER_GROWTH`,
  FAIRE_POD_COMMUNICATIONS_PLATFORM: undefined,
  FAIRE_POD_OPEN_WITH_FAIRE: undefined,
  FAIRE_POD_COMMISSION: undefined,
  FAIRE_POD_FAIRE_DIRECT_GROWTH: `FAIRE_ONCALL_RETAILER_GROWTH`,
  FAIRE_POD_SHOPIFY: undefined,
  FAIRE_POD_RETAILER_POS_INTEGRATIONS: `FAIRE_ONCALL_INTEGRATIONS`,
  FAIRE_POD_RETAILER_TOFU: `FAIRE_ONCALL_RETAILER_GROWTH`,
  FAIRE_POD_BROWSE: `FAIRE_ONCALL_DISCOVERY`,
  FAIRE_POD_DATA_TEAM_FINANCIAL_PRODUCTS: `FAIRE_ONCALL_ANTI_ABUSE`,
  FAIRE_POD_RECOMMENDATIONS: `FAIRE_ONCALL_DISCOVERY`,
  FAIRE_POD_SEARCH_EXPERIENCE_ACCELERATOR: `FAIRE_ONCALL_DISCOVERY_INFRA_AND_ENABLEMENT`,
  FAIRE_POD_INTERNATIONAL_FOUNDATIONS: undefined,
  FAIRE_POD_SUPPORT_EXPERIENCE: `FAIRE_ONCALL_RETAILER_TOOLS_AND_PROGRAMS`,
  FAIRE_POD_BRAND_CATALOG_COMPLETENESS: `FAIRE_ONCALL_BRAND`,
  FAIRE_POD_GROWTH_PLATFORM: `FAIRE_ONCALL_RETAILER_GROWTH`,
  FAIRE_POD_RETAILER_ORDER_PLACEMENT: `FAIRE_ONCALL_VALUE`,
  FAIRE_POD_RETAILER_ORDER_MANAGEMENT: `FAIRE_ONCALL_RETAILER_TOOLS_AND_PROGRAMS`,
  FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT: `FAIRE_ONCALL_BRAND`,
  FAIRE_POD_BRAND_PRICING_AND_REORDERS: undefined,
  FAIRE_POD_BRAND_CATALOG_COMPLETENESS_AND_BRAND_PROGRAMS: undefined,
  FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES: `FAIRE_ONCALL_BRAND`,
  FAIRE_POD_DISCOVERY_INFRA_ENABLEMENT: `FAIRE_ONCALL_DISCOVERY_INFRA_AND_ENABLEMENT`,
  FAIRE_POD_EXPERIMENT_PLATFORM: `FAIRE_ONCALL_DATA_SCIENCE_ML_PLATFORM`,
  FAIRE_POD_KNOWLEDGE_GRAPH: `FAIRE_ONCALL_DATA_SCIENCE_ML_PLATFORM`,
  FAIRE_POD_PLATFORM_PRODUCTIVITY: `FAIRE_ONCALL_PLATFORM`,
  FAIRE_POD_DISCOVERY_PRODUCT_PLATFORM: `FAIRE_ONCALL_DISCOVERY`,
  FAIRE_POD_PERSONALIZATION: `FAIRE_ONCALL_DISCOVERY_INFRA_AND_ENABLEMENT`,
  FAIRE_POD_BRAND_CATALOG_GROWTH: `FAIRE_ONCALL_BRAND`,
  FAIRE_POD_SEARCH_QUERY_UNDERSTANDING_AND_RETRIEVAL: `FAIRE_ONCALL_DISCOVERY_INFRA_AND_ENABLEMENT`,
  FAIRE_POD_CORE_DATA_INFRA: `FAIRE_ONCALL_DATA_SCIENCE_CORE_DATA_INFRASTRUCTURE`,
  FAIRE_POD_PP_ADS_MANAGER: `FAIRE_ONCALL_ADS`,
  FAIRE_POD_PP_ADS_DELIVERY: `FAIRE_ONCALL_ADS`,
  FAIRE_POD_RETAILER_GROWTH_DATA_SCIENCE: `FAIRE_ONCALL_RETAILER_GROWTH`,
  FAIRE_POD_BRAND_DATA_SCIENCE: `FAIRE_ONCALL_BRAND`,
  FAIRE_POD_DATA_TEAM_INSIDER_AND_SHIPPING_COSTS: `FAIRE_ONCALL_VALUE`,
  FAIRE_POD_VALUE_MOBILE: `FAIRE_ONCALL_VALUE`,
  FAIRE_POD_AI_PLATFORM: `FAIRE_ONCALL_DATA_SCIENCE_ML_PLATFORM`,
  FAIRE_POD_OPS_ENABLEMENT: `FAIRE_ONCALL_VALUE`,
  FAIRE_POD_EVALUATE: `FAIRE_ONCALL_DISCOVERY`,
  FAIRE_POD_ADS: `FAIRE_ONCALL_ADS`,
  FAIRE_POD_ADS_DELIVERY: `FAIRE_ONCALL_ADS`,
  FAIRE_POD_ADS_MANAGER: `FAIRE_ONCALL_ADS`,
  FAIRE_POD_ADVERTISER_GROWTH: `FAIRE_ONCALL_ADS`,
  FAIRE_POD_ADS_BIDDING: `FAIRE_ONCALL_ADS`,
  FAIRE_POD_BRAND_PLATFORM: `FAIRE_ONCALL_BRAND`,
  FAIRE_POD_BRAND_PLATFORM_COMPLIANCE: `FAIRE_ONCALL_BRAND`,
  FAIRE_POD_ORDERS_MIGRATION: `FAIRE_ONCALL_VALUE`,
  FAIRE_POD_FAIRE_PAY: `FAIRE_ONCALL_VALUE`,
  FAIRE_POD_ONE_STOP_SHOP: `FAIRE_ONCALL_VALUE`,
  FAIRE_POD_MARKETS_COORDINATION: `FAIRE_ONCALL_VALUE`,
  FAIRE_POD_FULFILLED_BY_FAIRE: `FAIRE_ONCALL_VALUE`,
  FAIRE_POD_FULFILLMENT: `FAIRE_ONCALL_VALUE`,
  FAIRE_POD_SEARCH_UX: `FAIRE_ONCALL_DISCOVERY_INFRA_AND_ENABLEMENT`,
  FAIRE_POD_RELATIONSHIP_GROWTH: `FAIRE_ONCALL_RETAILER_GROWTH`,
  FAIRE_POD_RETAILER_EXPERIENCE: `FAIRE_ONCALL_DISCOVERY`,
  FAIRE_POD_UPMARKET_PLUS: `FAIRE_ONCALL_RETAILER_GROWTH`,
  FAIRE_POD_ANALYTICS_PLATFORM: `FAIRE_ONCALL_ANALYTICS_PLATFORM`,
  FAIRE_POD_VALUE_PLATFORM: `FAIRE_ONCALL_VALUE`,
  FAIRE_POD_PLATFORM_CODE_AUTHORING: `FAIRE_ONCALL_PLATFORM`,
  FAIRE_POD_PLATFORM_CODE_REVIEW: `FAIRE_ONCALL_PLATFORM`,
  FAIRE_POD_PLATFORM_CODE_RELEASE: `FAIRE_ONCALL_PLATFORM`,
  FAIRE_POD_FINTECH_AND_OPS: `FAIRE_ONCALL_VALUE`,
  FAIRE_POD_SEARCH_FX: `FAIRE_ONCALL_DISCOVERY_INFRA_AND_ENABLEMENT`,
  FAIRE_POD_CLIENT_PLATFORM: undefined,
  FAIRE_POD_CLIENT_FOUNDATIONS: undefined,
  FAIRE_POD_MARKETING_OPERATIONS: `FAIRE_ONCALL_RETAILER_GROWTH`,
  FAIRE_POD_APP: `FAIRE_ONCALL_DISCOVERY`,
  FAIRE_POD_ORDER_REORDER: `FAIRE_ONCALL_DISCOVERY`,
  FAIRE_POD_OPENING_SOON: `FAIRE_ONCALL_RETAILER_GROWTH`,
  FAIRE_POD_ADS_SUPPLY: `FAIRE_ONCALL_ADS`,
  FAIRE_POD_COMPASS: `FAIRE_ONCALL_DISCOVERY`,
  FAIRE_POD_PREORDERS_AND_CUSTOM: `FAIRE_ONCALL_BRAND`,
};

export const getOncallForFairePod = (
  enumValue: FairePod | keyof typeof FairePod
): keyof typeof FaireOncall | undefined => {
  return oncallForFairePod[enumValue];
};

const managerEmailForFairePod: Partial<Record<FairePod, string>> = {
  FAIRE_POD_UNKNOWN: undefined,
  FAIRE_POD_ANTI_ABUSE: `jevin@faire.com`,
  FAIRE_POD_APPAREL: undefined,
  FAIRE_POD_APPAREL_BRAND: undefined,
  FAIRE_POD_APPAREL_EVENTS: undefined,
  FAIRE_POD_APPAREL_PREORDER: undefined,
  FAIRE_POD_APPAREL_RETAILER: undefined,
  FAIRE_POD_BRAND_ACQUISITION: `preshoth.paramalingam@faire.com`,
  FAIRE_POD_BRAND_GROWTH: undefined,
  FAIRE_POD_BRAND_MARKETPLACE_QUALITY: undefined,
  FAIRE_POD_BRAND_ONBOARDING: undefined,
  FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM: `preshoth.paramalingam@faire.com`,
  FAIRE_POD_BRAND_ORDER_MANAGEMENT: undefined,
  FAIRE_POD_BRAND_FAIRE_DIRECT: undefined,
  FAIRE_POD_CATEGORY_INCUBATION: undefined,
  FAIRE_POD_DATA: undefined,
  FAIRE_POD_DISCOVERY_AI: `tom.ma@faire.com`,
  FAIRE_POD_DISCOVERY_AE: `samir.durrani@faire.com`,
  FAIRE_POD_DISCOVERY_LOGGING: `elijah.flesher@faire.com`,
  FAIRE_POD_FAIRE_FOUNDATIONS: `dale.hamill@faire.com`,
  FAIRE_POD_INTEGRATIONS: undefined,
  FAIRE_POD_INTERNAL_TOOLS: undefined,
  FAIRE_POD_INTERNATIONAL: undefined,
  FAIRE_POD_INTERNATIONAL_BRAND_GROWTH: undefined,
  FAIRE_POD_INTERNATIONAL_BRAND: `gray@faire.com`,
  FAIRE_POD_INTERNATIONAL_LAUNCH: undefined,
  FAIRE_POD_INTERNATIONAL_PLATFORM: undefined,
  FAIRE_POD_MARKETS: `julian.konomi@faire.com`,
  FAIRE_POD_RETAILER_PRICING: `alexandre.bisson@faire.com`,
  FAIRE_POD_SHIPPING: `derek.gleeson@faire.com`,
  FAIRE_POD_MARKETPLACE_QUALITY: `gaurav.saraf@faire.com`,
  FAIRE_POD_MOBILE: undefined,
  FAIRE_POD_MOBILE_STRIKE: `raissa.nucci@faire.com`,
  FAIRE_POD_MOBILE_CORE: undefined,
  FAIRE_POD_MOBILE_PLATFORM: `ragan.vadlamudi@faire.com`,
  FAIRE_POD_MOBILE_EXPANSION: undefined,
  FAIRE_POD_MOBILE_INTERNATIONAL: `ani.borah@faire.com`,
  FAIRE_POD_MULTI_SERVICE: undefined,
  FAIRE_POD_PLATFORM: `ryan@faire.com`,
  FAIRE_POD_PLATFORM_CONTROL: `cheuk-man.kong@faire.com`,
  FAIRE_POD_PLATFORM_SCALE: `felix.reyn@faire.com`,
  FAIRE_POD_PLATFORM_RELIABILITY: `felix.reyn@faire.com`,
  FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS: `khaled.said@faire.com`,
  FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCE: `felix.reyn@faire.com`,
  FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY: `khaled.said@faire.com`,
  FAIRE_POD_PLATFORM_TAP: undefined,
  FAIRE_POD_BRAND_INFRASTRUCTURE: `mark.widish@faire.com`,
  FAIRE_POD_PREORDERS: undefined,
  FAIRE_POD_PRICING: undefined,
  FAIRE_POD_BRAND_PRICING: undefined,
  FAIRE_POD_QUALITY: `bryan.holder@faire.com`,
  FAIRE_POD_RISK: undefined,
  FAIRE_POD_SECURITY: `bryan.holder@faire.com`,
  FAIRE_POD_RETAILER_LIFECYCLE: undefined,
  FAIRE_POD_RETAILER_CONFIDENCE: undefined,
  FAIRE_POD_RETAILER_GROWTH: undefined,
  FAIRE_POD_RETAILER_ACTIVATION: `luthfur.chowdhury@faire.com`,
  FAIRE_POD_RETAILER_ONBOARDING: `alier.hu@faire.com`,
  FAIRE_POD_RETAILER_DISCOVERY: undefined,
  FAIRE_POD_INSIDER: `milan.stanivuk@faire.com`,
  FAIRE_POD_UNASSIGNED: undefined,
  FAIRE_POD_BRAND_UNASSIGNED: `mark.fennema@faire.com`,
  FAIRE_POD_WEB_PLATFORM: `ragan.vadlamudi@faire.com`,
  FAIRE_POD_CLIENT_TOOLS: undefined,
  FAIRE_POD_RETAILER_UNDERWRITING: undefined,
  FAIRE_POD_ORDER_WRITING: undefined,
  FAIRE_POD_LOCALIZATION: undefined,
  FAIRE_POD_BRAND_MARKETPLACE_SUCCESS: undefined,
  FAIRE_POD_STABLE_STAPLES: undefined,
  FAIRE_POD_FINANCIAL_PRODUCTS: `neel.hajare@faire.com`,
  FAIRE_POD_UPMARKET: undefined,
  FAIRE_POD_RETAILER_INSPIRE: `dmytro.landberg@faire.com`,
  FAIRE_POD_RETAILER_SEARCH: `eric.hacke@faire.com`,
  FAIRE_POD_RETAILER_CHECKOUT: undefined,
  FAIRE_POD_RETAILER_ACQUISITION: `pavlo.kuzhel@faire.com`,
  FAIRE_POD_RETAILER_EVALUATE: undefined,
  FAIRE_POD_FAIRE_DIRECT_REWARDS: undefined,
  FAIRE_POD_FAIRE_DIRECT_CRM: undefined,
  FAIRE_POD_FAIRE_DIRECT_PROSPECTING: undefined,
  FAIRE_POD_APPAREL_INTEGRATIONS: `cedo.segulja@faire.com`,
  FAIRE_POD_BRAND_F30D_LIFECYCLE: undefined,
  FAIRE_POD_INTERNATIONAL_TRANSLATION: `dave.collie@faire.com`,
  FAIRE_POD_INVOICING_AND_SUPPORT_EXPERIENCE: `ryan.orr@faire.com`,
  FAIRE_POD_VAT_INTL_CX: undefined,
  FAIRE_POD_INTERNATIONAL_CX: undefined,
  FAIRE_POD_XB_SHIPPING: undefined,
  FAIRE_POD_SHIPPING_EXPERIENCE: undefined,
  FAIRE_POD_RETAILER_INFRASTRUCTURE: undefined,
  FAIRE_POD_RETAILER_TAXONOMY: `eliot.daigneaultmestre@faire.com`,
  FAIRE_POD_FOOD_AND_BEVERAGE: `dmytro.landberg@faire.com`,
  FAIRE_POD_UPMARKET_GROWTH: undefined,
  FAIRE_POD_UPMARKET_EXPERIENCE: `howard.pang@faire.com`,
  FAIRE_POD_FREIGHT_MARGIN: `ani.borah@faire.com`,
  FAIRE_POD_RETAILER_REORDER: undefined,
  FAIRE_POD_BRAND_ENTERPRISE: undefined,
  FAIRE_POD_SLATE_DESIGN_SYSTEM: undefined,
  FAIRE_POD_DESIGN_PLATFORM: `ragan.vadlamudi@faire.com`,
  FAIRE_POD_SEARCH_INFRASTRUCTURE: `eliot.daigneaultmestre@faire.com`,
  FAIRE_POD_RETAILER_CART_SERVICE: undefined,
  FAIRE_POD_UPMARKET_TEAM_MANAGEMENT: `howard.pang@faire.com`,
  FAIRE_POD_UPMARKET_TOOLING: `mark.fennema@faire.com`,
  FAIRE_POD_RETENTION_EXPERIENCE: undefined,
  FAIRE_POD_RETAILER_SEO: undefined,
  FAIRE_POD_BRAND_SERVICE_STANDARDS: undefined,
  FAIRE_POD_SUPPLY_INTEGRITY: undefined,
  FAIRE_POD_RETAILER_SUCCESS: `thiago.pilon@faire.com`,
  FAIRE_POD_THEMATIC_DISCOVERY: undefined,
  FAIRE_POD_TAXONOMY: `eliot.daigneaultmestre@faire.com`,
  FAIRE_POD_SEARCH_EXPERIENCE: `austin.dobrik@faire.com`,
  FAIRE_POD_INSPIRE: `dmytro.landberg@faire.com`,
  FAIRE_POD_SEARCH_RANKING_ALGORITHMS: `yizheng.liao@faire.com`,
  FAIRE_POD_DISCOVERY_PAID_PLACEMENT: `ani.borah@faire.com`,
  FAIRE_POD_GROWTH_MOBILE: `luthfur.chowdhury@faire.com`,
  FAIRE_POD_COMMUNICATIONS_PLATFORM: undefined,
  FAIRE_POD_OPEN_WITH_FAIRE: undefined,
  FAIRE_POD_COMMISSION: undefined,
  FAIRE_POD_FAIRE_DIRECT_GROWTH: `haris.mahmood@faire.com`,
  FAIRE_POD_SHOPIFY: undefined,
  FAIRE_POD_RETAILER_POS_INTEGRATIONS: `howard.pang@faire.com`,
  FAIRE_POD_RETAILER_TOFU: `mario.hebert@faire.com`,
  FAIRE_POD_BROWSE: `raissa.nucci@faire.com`,
  FAIRE_POD_DATA_TEAM_FINANCIAL_PRODUCTS: `georgii@faire.com`,
  FAIRE_POD_RECOMMENDATIONS: `dmytro.landberg@faire.com`,
  FAIRE_POD_SEARCH_EXPERIENCE_ACCELERATOR: `dmytro.landberg@faire.com`,
  FAIRE_POD_INTERNATIONAL_FOUNDATIONS: undefined,
  FAIRE_POD_SUPPORT_EXPERIENCE: `matthew.d-cruz@faire.com`,
  FAIRE_POD_BRAND_CATALOG_COMPLETENESS: `donald.ho@faire.com`,
  FAIRE_POD_GROWTH_PLATFORM: `jake@faire.com`,
  FAIRE_POD_RETAILER_ORDER_PLACEMENT: `neel.hajare@faire.com`,
  FAIRE_POD_RETAILER_ORDER_MANAGEMENT: `matthew.d-cruz@faire.com`,
  FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT: `preshoth.paramalingam@faire.com`,
  FAIRE_POD_BRAND_PRICING_AND_REORDERS: undefined,
  FAIRE_POD_BRAND_CATALOG_COMPLETENESS_AND_BRAND_PROGRAMS: undefined,
  FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES: `ryan.closner@faire.com`,
  FAIRE_POD_DISCOVERY_INFRA_ENABLEMENT: `elijah.flesher@faire.com`,
  FAIRE_POD_EXPERIMENT_PLATFORM: `michael.tompkins@faire.com`,
  FAIRE_POD_KNOWLEDGE_GRAPH: `robby.zeller@faire.com`,
  FAIRE_POD_PLATFORM_PRODUCTIVITY: `cheuk-man.kong@faire.com`,
  FAIRE_POD_DISCOVERY_PRODUCT_PLATFORM: `raissa.nucci@faire.com`,
  FAIRE_POD_PERSONALIZATION: `yuanchi.ning@faire.com`,
  FAIRE_POD_BRAND_CATALOG_GROWTH: `ryan.closner@faire.com`,
  FAIRE_POD_SEARCH_QUERY_UNDERSTANDING_AND_RETRIEVAL: `roman.shraga@faire.com`,
  FAIRE_POD_CORE_DATA_INFRA: `mike.moon@faire.com`,
  FAIRE_POD_PP_ADS_MANAGER: `tom.ma@faire.com`,
  FAIRE_POD_PP_ADS_DELIVERY: `ani.borah@faire.com`,
  FAIRE_POD_RETAILER_GROWTH_DATA_SCIENCE: `robby.zeller@faire.com`,
  FAIRE_POD_BRAND_DATA_SCIENCE: `robby.zeller@faire.com`,
  FAIRE_POD_DATA_TEAM_INSIDER_AND_SHIPPING_COSTS: `jevin@faire.com`,
  FAIRE_POD_VALUE_MOBILE: `neel.hajare@faire.com`,
  FAIRE_POD_AI_PLATFORM: `mike.moon@faire.com`,
  FAIRE_POD_OPS_ENABLEMENT: `dave.collie@faire.com`,
  FAIRE_POD_EVALUATE: `elijah.flesher@faire.com`,
  FAIRE_POD_ADS: `ani.borah@faire.com`,
  FAIRE_POD_ADS_DELIVERY: `ani.borah@faire.com`,
  FAIRE_POD_ADS_MANAGER: `tom.ma@faire.com`,
  FAIRE_POD_ADVERTISER_GROWTH: `tom.ma@faire.com`,
  FAIRE_POD_ADS_BIDDING: `ani.borah@faire.com`,
  FAIRE_POD_BRAND_PLATFORM: `gaurav.saraf@faire.com`,
  FAIRE_POD_BRAND_PLATFORM_COMPLIANCE: `ryan.closner@faire.com`,
  FAIRE_POD_ORDERS_MIGRATION: `neel.hajare@faire.com`,
  FAIRE_POD_FAIRE_PAY: `tobi.kral@faire.com`,
  FAIRE_POD_ONE_STOP_SHOP: `derek.gleeson@faire.com`,
  FAIRE_POD_MARKETS_COORDINATION: `mark.fennema@faire.com`,
  FAIRE_POD_FULFILLED_BY_FAIRE: `alexandre.bisson@faire.com`,
  FAIRE_POD_FULFILLMENT: `alexandre.bisson@faire.com`,
  FAIRE_POD_SEARCH_UX: `raissa.nucci@faire.com`,
  FAIRE_POD_RELATIONSHIP_GROWTH: `haris.mahmood@faire.com`,
  FAIRE_POD_RETAILER_EXPERIENCE: `raissa.nucci@faire.com`,
  FAIRE_POD_UPMARKET_PLUS: `pavlo.kuzhel@faire.com`,
  FAIRE_POD_ANALYTICS_PLATFORM: `felix.reyn@faire.com`,
  FAIRE_POD_VALUE_PLATFORM: `neel.hajare@faire.com`,
  FAIRE_POD_PLATFORM_CODE_AUTHORING: `george.jacob@faire.com`,
  FAIRE_POD_PLATFORM_CODE_REVIEW: `cheuk-man.kong@faire.com`,
  FAIRE_POD_PLATFORM_CODE_RELEASE: `cheuk-man.kong@faire.com`,
  FAIRE_POD_FINTECH_AND_OPS: `geoff.pounder@faire.com`,
  FAIRE_POD_SEARCH_FX: `ani.borah@faire.com`,
  FAIRE_POD_CLIENT_PLATFORM: `ragan.vadlamudi@faire.com`,
  FAIRE_POD_CLIENT_FOUNDATIONS: `ragan.vadlamudi@faire.com`,
  FAIRE_POD_MARKETING_OPERATIONS: `dylan.tolliver@faire.com`,
  FAIRE_POD_APP: `raissa.nucci@faire.com`,
  FAIRE_POD_ORDER_REORDER: `austin.dobrik@faire.com`,
  FAIRE_POD_OPENING_SOON: `luthfur.chowdhury@faire.com`,
  FAIRE_POD_ADS_SUPPLY: `tom.ma@faire.com`,
  FAIRE_POD_COMPASS: `dmytro.landberg@faire.com`,
  FAIRE_POD_PREORDERS_AND_CUSTOM: `gaurav.saraf@faire.com`,
};

export const getManagerEmailForFairePod = (
  enumValue: FairePod | keyof typeof FairePod
): string | undefined => {
  return managerEmailForFairePod[enumValue];
};

const slackChannelOverrideForFairePod: Partial<Record<FairePod, string>> = {
  FAIRE_POD_UNKNOWN: undefined,
  FAIRE_POD_ANTI_ABUSE: `anti-abuse-alerts`,
  FAIRE_POD_APPAREL: undefined,
  FAIRE_POD_APPAREL_BRAND: undefined,
  FAIRE_POD_APPAREL_EVENTS: undefined,
  FAIRE_POD_APPAREL_PREORDER: undefined,
  FAIRE_POD_APPAREL_RETAILER: undefined,
  FAIRE_POD_BRAND_ACQUISITION: `pod-brand-acquisition-alerts`,
  FAIRE_POD_BRAND_GROWTH: undefined,
  FAIRE_POD_BRAND_MARKETPLACE_QUALITY: undefined,
  FAIRE_POD_BRAND_ONBOARDING: undefined,
  FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM: `pod-boat-alerts`,
  FAIRE_POD_BRAND_ORDER_MANAGEMENT: undefined,
  FAIRE_POD_BRAND_FAIRE_DIRECT: undefined,
  FAIRE_POD_CATEGORY_INCUBATION: undefined,
  FAIRE_POD_DATA: `data-alerts`,
  FAIRE_POD_DISCOVERY_AI: undefined,
  FAIRE_POD_DISCOVERY_AE: undefined,
  FAIRE_POD_DISCOVERY_LOGGING: `disco-logging-jira`,
  FAIRE_POD_FAIRE_FOUNDATIONS: undefined,
  FAIRE_POD_INTEGRATIONS: undefined,
  FAIRE_POD_INTERNAL_TOOLS: undefined,
  FAIRE_POD_INTERNATIONAL: undefined,
  FAIRE_POD_INTERNATIONAL_BRAND_GROWTH: undefined,
  FAIRE_POD_INTERNATIONAL_BRAND: undefined,
  FAIRE_POD_INTERNATIONAL_LAUNCH: undefined,
  FAIRE_POD_INTERNATIONAL_PLATFORM: undefined,
  FAIRE_POD_MARKETS: undefined,
  FAIRE_POD_RETAILER_PRICING: `pod-retailer-pricing-alerts`,
  FAIRE_POD_SHIPPING: undefined,
  FAIRE_POD_MARKETPLACE_QUALITY: `pod-marketplace-quality-alerts`,
  FAIRE_POD_MOBILE: undefined,
  FAIRE_POD_MOBILE_STRIKE: undefined,
  FAIRE_POD_MOBILE_CORE: undefined,
  FAIRE_POD_MOBILE_PLATFORM: `pod-mobile-platform-notifications`,
  FAIRE_POD_MOBILE_EXPANSION: undefined,
  FAIRE_POD_MOBILE_INTERNATIONAL: undefined,
  FAIRE_POD_MULTI_SERVICE: undefined,
  FAIRE_POD_PLATFORM: `pod-platform-updates`,
  FAIRE_POD_PLATFORM_CONTROL: undefined,
  FAIRE_POD_PLATFORM_SCALE: undefined,
  FAIRE_POD_PLATFORM_RELIABILITY: undefined,
  FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS: undefined,
  FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCE: undefined,
  FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY: undefined,
  FAIRE_POD_PLATFORM_TAP: undefined,
  FAIRE_POD_BRAND_INFRASTRUCTURE: undefined,
  FAIRE_POD_PREORDERS: undefined,
  FAIRE_POD_PRICING: undefined,
  FAIRE_POD_BRAND_PRICING: undefined,
  FAIRE_POD_QUALITY: undefined,
  FAIRE_POD_RISK: undefined,
  FAIRE_POD_SECURITY: undefined,
  FAIRE_POD_RETAILER_LIFECYCLE: undefined,
  FAIRE_POD_RETAILER_CONFIDENCE: undefined,
  FAIRE_POD_RETAILER_GROWTH: undefined,
  FAIRE_POD_RETAILER_ACTIVATION: `pod-retailer-activation-alerts`,
  FAIRE_POD_RETAILER_ONBOARDING: `pod-retailer-onboarding-notifications`,
  FAIRE_POD_RETAILER_DISCOVERY: undefined,
  FAIRE_POD_INSIDER: `pod-insider-sla`,
  FAIRE_POD_UNASSIGNED: undefined,
  FAIRE_POD_BRAND_UNASSIGNED: `pillar-brand-eng-sla`,
  FAIRE_POD_WEB_PLATFORM: undefined,
  FAIRE_POD_CLIENT_TOOLS: undefined,
  FAIRE_POD_RETAILER_UNDERWRITING: undefined,
  FAIRE_POD_ORDER_WRITING: undefined,
  FAIRE_POD_LOCALIZATION: undefined,
  FAIRE_POD_BRAND_MARKETPLACE_SUCCESS: undefined,
  FAIRE_POD_STABLE_STAPLES: undefined,
  FAIRE_POD_FINANCIAL_PRODUCTS: `pod-financial-products-sla`,
  FAIRE_POD_UPMARKET: undefined,
  FAIRE_POD_RETAILER_INSPIRE: `pod-retailer-inspire-notifications`,
  FAIRE_POD_RETAILER_SEARCH: undefined,
  FAIRE_POD_RETAILER_CHECKOUT: undefined,
  FAIRE_POD_RETAILER_ACQUISITION: `pod-acquisition-notifications`,
  FAIRE_POD_RETAILER_EVALUATE: undefined,
  FAIRE_POD_FAIRE_DIRECT_REWARDS: undefined,
  FAIRE_POD_FAIRE_DIRECT_CRM: undefined,
  FAIRE_POD_FAIRE_DIRECT_PROSPECTING: undefined,
  FAIRE_POD_APPAREL_INTEGRATIONS: undefined,
  FAIRE_POD_BRAND_F30D_LIFECYCLE: undefined,
  FAIRE_POD_INTERNATIONAL_TRANSLATION: undefined,
  FAIRE_POD_INVOICING_AND_SUPPORT_EXPERIENCE: `pod-invoicing-support-experience`,
  FAIRE_POD_VAT_INTL_CX: undefined,
  FAIRE_POD_INTERNATIONAL_CX: undefined,
  FAIRE_POD_XB_SHIPPING: undefined,
  FAIRE_POD_SHIPPING_EXPERIENCE: undefined,
  FAIRE_POD_RETAILER_INFRASTRUCTURE: undefined,
  FAIRE_POD_RETAILER_TAXONOMY: undefined,
  FAIRE_POD_FOOD_AND_BEVERAGE: undefined,
  FAIRE_POD_UPMARKET_GROWTH: undefined,
  FAIRE_POD_UPMARKET_EXPERIENCE: undefined,
  FAIRE_POD_FREIGHT_MARGIN: undefined,
  FAIRE_POD_RETAILER_REORDER: undefined,
  FAIRE_POD_BRAND_ENTERPRISE: undefined,
  FAIRE_POD_SLATE_DESIGN_SYSTEM: undefined,
  FAIRE_POD_DESIGN_PLATFORM: `pod-design-platform`,
  FAIRE_POD_SEARCH_INFRASTRUCTURE: `pod-discovery-infra-enablement`,
  FAIRE_POD_RETAILER_CART_SERVICE: undefined,
  FAIRE_POD_UPMARKET_TEAM_MANAGEMENT: undefined,
  FAIRE_POD_UPMARKET_TOOLING: `pod-upmarket-tooling-sla`,
  FAIRE_POD_RETENTION_EXPERIENCE: undefined,
  FAIRE_POD_RETAILER_SEO: undefined,
  FAIRE_POD_BRAND_SERVICE_STANDARDS: undefined,
  FAIRE_POD_SUPPLY_INTEGRITY: undefined,
  FAIRE_POD_RETAILER_SUCCESS: undefined,
  FAIRE_POD_THEMATIC_DISCOVERY: undefined,
  FAIRE_POD_TAXONOMY: `pod-discovery-infra-enablement`,
  FAIRE_POD_SEARCH_EXPERIENCE: `pod-evaluate-and-order-notifications`,
  FAIRE_POD_INSPIRE: `pod-discovery-inspire-alerts`,
  FAIRE_POD_SEARCH_RANKING_ALGORITHMS: `search-algo-alerts`,
  FAIRE_POD_DISCOVERY_PAID_PLACEMENT: `pod-discovery-paid-placement-sla`,
  FAIRE_POD_GROWTH_MOBILE: `retailer-growth-mobile-sla`,
  FAIRE_POD_COMMUNICATIONS_PLATFORM: undefined,
  FAIRE_POD_OPEN_WITH_FAIRE: undefined,
  FAIRE_POD_COMMISSION: undefined,
  FAIRE_POD_FAIRE_DIRECT_GROWTH: `pod-faire-direct-growth-notifications`,
  FAIRE_POD_SHOPIFY: undefined,
  FAIRE_POD_RETAILER_POS_INTEGRATIONS: `pod-retailer-pos-integrations-sla`,
  FAIRE_POD_RETAILER_TOFU: undefined,
  FAIRE_POD_BROWSE: `pod-browse-sla`,
  FAIRE_POD_DATA_TEAM_FINANCIAL_PRODUCTS: `data-team-financial-products`,
  FAIRE_POD_RECOMMENDATIONS: `pod-discovery-recommendations`,
  FAIRE_POD_SEARCH_EXPERIENCE_ACCELERATOR: undefined,
  FAIRE_POD_INTERNATIONAL_FOUNDATIONS: undefined,
  FAIRE_POD_SUPPORT_EXPERIENCE: undefined,
  FAIRE_POD_BRAND_CATALOG_COMPLETENESS: undefined,
  FAIRE_POD_GROWTH_PLATFORM: `pod-growth-platform-notifications`,
  FAIRE_POD_RETAILER_ORDER_PLACEMENT: `pod-retailer-order-placement-sla`,
  FAIRE_POD_RETAILER_ORDER_MANAGEMENT: `pod-retailer-order-management-sla`,
  FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT: `pod-bom`,
  FAIRE_POD_BRAND_PRICING_AND_REORDERS: undefined,
  FAIRE_POD_BRAND_CATALOG_COMPLETENESS_AND_BRAND_PROGRAMS: undefined,
  FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES: `pod-listing-quality-product-attributes-alerts`,
  FAIRE_POD_DISCOVERY_INFRA_ENABLEMENT: undefined,
  FAIRE_POD_EXPERIMENT_PLATFORM: undefined,
  FAIRE_POD_KNOWLEDGE_GRAPH: undefined,
  FAIRE_POD_PLATFORM_PRODUCTIVITY: `pod-platform-productivity`,
  FAIRE_POD_DISCOVERY_PRODUCT_PLATFORM: undefined,
  FAIRE_POD_PERSONALIZATION: undefined,
  FAIRE_POD_BRAND_CATALOG_GROWTH: `pod-brand-catalog-growth-notifications`,
  FAIRE_POD_SEARCH_QUERY_UNDERSTANDING_AND_RETRIEVAL: `search-algo-alerts`,
  FAIRE_POD_CORE_DATA_INFRA: `pod-platform-data-infrastructure`,
  FAIRE_POD_PP_ADS_MANAGER: `pod-discovery-paid-placement-sla`,
  FAIRE_POD_PP_ADS_DELIVERY: `pod-discovery-paid-placement-sla`,
  FAIRE_POD_RETAILER_GROWTH_DATA_SCIENCE: undefined,
  FAIRE_POD_BRAND_DATA_SCIENCE: undefined,
  FAIRE_POD_DATA_TEAM_INSIDER_AND_SHIPPING_COSTS: undefined,
  FAIRE_POD_VALUE_MOBILE: undefined,
  FAIRE_POD_AI_PLATFORM: `ml-help`,
  FAIRE_POD_OPS_ENABLEMENT: undefined,
  FAIRE_POD_EVALUATE: `pod-evaluate-notifications`,
  FAIRE_POD_ADS: `pod-discovery-paid-placement-sla`,
  FAIRE_POD_ADS_DELIVERY: `pod-ads-delivery-sla`,
  FAIRE_POD_ADS_MANAGER: `pod-discovery-paid-placement-sla`,
  FAIRE_POD_ADVERTISER_GROWTH: `pod-discovery-advertiser-growth-sla`,
  FAIRE_POD_ADS_BIDDING: `pod-ads-bidding-sla`,
  FAIRE_POD_BRAND_PLATFORM: undefined,
  FAIRE_POD_BRAND_PLATFORM_COMPLIANCE: undefined,
  FAIRE_POD_ORDERS_MIGRATION: `service-orders`,
  FAIRE_POD_FAIRE_PAY: `pod-faire-pay-sla`,
  FAIRE_POD_ONE_STOP_SHOP: `pod-one-stop-shop-sla`,
  FAIRE_POD_MARKETS_COORDINATION: undefined,
  FAIRE_POD_FULFILLED_BY_FAIRE: `pod-fbf-sla`,
  FAIRE_POD_FULFILLMENT: `pod-fulfillment-sla`,
  FAIRE_POD_SEARCH_UX: `pod-search-ux-sla`,
  FAIRE_POD_RELATIONSHIP_GROWTH: `pod-relationship-growth-notifications`,
  FAIRE_POD_RETAILER_EXPERIENCE: undefined,
  FAIRE_POD_UPMARKET_PLUS: `pod-upmarket-plus-notifications`,
  FAIRE_POD_ANALYTICS_PLATFORM: `pod-platform-analytics`,
  FAIRE_POD_VALUE_PLATFORM: undefined,
  FAIRE_POD_PLATFORM_CODE_AUTHORING: `pod-platform-code-authoring`,
  FAIRE_POD_PLATFORM_CODE_REVIEW: `pod-platform-code-review`,
  FAIRE_POD_PLATFORM_CODE_RELEASE: `pod-platform-code-release`,
  FAIRE_POD_FINTECH_AND_OPS: `pod-fintech-and-ops-sla`,
  FAIRE_POD_SEARCH_FX: `pod-search-fx-sla`,
  FAIRE_POD_CLIENT_PLATFORM: undefined,
  FAIRE_POD_CLIENT_FOUNDATIONS: undefined,
  FAIRE_POD_MARKETING_OPERATIONS: undefined,
  FAIRE_POD_APP: undefined,
  FAIRE_POD_ORDER_REORDER: `pod-order-reorder-notifications`,
  FAIRE_POD_OPENING_SOON: `pod-opening-soon-notifications`,
  FAIRE_POD_ADS_SUPPLY: `pod-ads-supply-sla`,
  FAIRE_POD_COMPASS: undefined,
  FAIRE_POD_PREORDERS_AND_CUSTOM: `pod-brand-preorders-and-custom-alerts`,
};

export const getSlackChannelOverrideForFairePod = (
  enumValue: FairePod | keyof typeof FairePod
): string | undefined => {
  return slackChannelOverrideForFairePod[enumValue];
};

const linearTeamIdForFairePod: Partial<Record<FairePod, string>> = {
  FAIRE_POD_UNKNOWN: undefined,
  FAIRE_POD_ANTI_ABUSE: `0942e9e6-cdf6-4178-8a0f-6ca5538edcc4`,
  FAIRE_POD_APPAREL: undefined,
  FAIRE_POD_APPAREL_BRAND: undefined,
  FAIRE_POD_APPAREL_EVENTS: undefined,
  FAIRE_POD_APPAREL_PREORDER: undefined,
  FAIRE_POD_APPAREL_RETAILER: undefined,
  FAIRE_POD_BRAND_ACQUISITION: undefined,
  FAIRE_POD_BRAND_GROWTH: undefined,
  FAIRE_POD_BRAND_MARKETPLACE_QUALITY: undefined,
  FAIRE_POD_BRAND_ONBOARDING: undefined,
  FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM: `9728d878-3c21-463c-98a9-0d3340c9258b`,
  FAIRE_POD_BRAND_ORDER_MANAGEMENT: undefined,
  FAIRE_POD_BRAND_FAIRE_DIRECT: undefined,
  FAIRE_POD_CATEGORY_INCUBATION: undefined,
  FAIRE_POD_DATA: undefined,
  FAIRE_POD_DISCOVERY_AI: undefined,
  FAIRE_POD_DISCOVERY_AE: `225791fd-5c26-45cb-a32d-6e3d0de20455`,
  FAIRE_POD_DISCOVERY_LOGGING: undefined,
  FAIRE_POD_FAIRE_FOUNDATIONS: undefined,
  FAIRE_POD_INTEGRATIONS: undefined,
  FAIRE_POD_INTERNAL_TOOLS: undefined,
  FAIRE_POD_INTERNATIONAL: undefined,
  FAIRE_POD_INTERNATIONAL_BRAND_GROWTH: undefined,
  FAIRE_POD_INTERNATIONAL_BRAND: undefined,
  FAIRE_POD_INTERNATIONAL_LAUNCH: undefined,
  FAIRE_POD_INTERNATIONAL_PLATFORM: undefined,
  FAIRE_POD_MARKETS: undefined,
  FAIRE_POD_RETAILER_PRICING: undefined,
  FAIRE_POD_SHIPPING: `59d7cc96-11eb-4f6b-a473-45befe05cb94`,
  FAIRE_POD_MARKETPLACE_QUALITY: `c8a373c0-2a45-4d4d-92fd-5f3a0a0e0545`,
  FAIRE_POD_MOBILE: undefined,
  FAIRE_POD_MOBILE_STRIKE: undefined,
  FAIRE_POD_MOBILE_CORE: undefined,
  FAIRE_POD_MOBILE_PLATFORM: undefined,
  FAIRE_POD_MOBILE_EXPANSION: undefined,
  FAIRE_POD_MOBILE_INTERNATIONAL: undefined,
  FAIRE_POD_MULTI_SERVICE: undefined,
  FAIRE_POD_PLATFORM: undefined,
  FAIRE_POD_PLATFORM_CONTROL: undefined,
  FAIRE_POD_PLATFORM_SCALE: undefined,
  FAIRE_POD_PLATFORM_RELIABILITY: undefined,
  FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS: `e1fc198a-e6bb-46ab-b05f-7ae14c9d0c9d`,
  FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCE: undefined,
  FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY: `d3ba40b8-9d83-4f5f-9a3f-cb857e04682f`,
  FAIRE_POD_PLATFORM_TAP: undefined,
  FAIRE_POD_BRAND_INFRASTRUCTURE: undefined,
  FAIRE_POD_PREORDERS: undefined,
  FAIRE_POD_PRICING: undefined,
  FAIRE_POD_BRAND_PRICING: undefined,
  FAIRE_POD_QUALITY: undefined,
  FAIRE_POD_RISK: undefined,
  FAIRE_POD_SECURITY: `3fa6efcf-2b9b-448d-b9cc-bd6b9f820300`,
  FAIRE_POD_RETAILER_LIFECYCLE: undefined,
  FAIRE_POD_RETAILER_CONFIDENCE: undefined,
  FAIRE_POD_RETAILER_GROWTH: undefined,
  FAIRE_POD_RETAILER_ACTIVATION: `f90f66be-f249-4cad-9f59-61e7d7f379ea`,
  FAIRE_POD_RETAILER_ONBOARDING: `ea4694ac-8786-4842-8f36-e5515b72e5c0`,
  FAIRE_POD_RETAILER_DISCOVERY: undefined,
  FAIRE_POD_INSIDER: `79c9dddc-0d5e-4806-995b-7a8a9187a5cc`,
  FAIRE_POD_UNASSIGNED: undefined,
  FAIRE_POD_BRAND_UNASSIGNED: undefined,
  FAIRE_POD_WEB_PLATFORM: undefined,
  FAIRE_POD_CLIENT_TOOLS: undefined,
  FAIRE_POD_RETAILER_UNDERWRITING: undefined,
  FAIRE_POD_ORDER_WRITING: undefined,
  FAIRE_POD_LOCALIZATION: undefined,
  FAIRE_POD_BRAND_MARKETPLACE_SUCCESS: undefined,
  FAIRE_POD_STABLE_STAPLES: undefined,
  FAIRE_POD_FINANCIAL_PRODUCTS: undefined,
  FAIRE_POD_UPMARKET: undefined,
  FAIRE_POD_RETAILER_INSPIRE: undefined,
  FAIRE_POD_RETAILER_SEARCH: undefined,
  FAIRE_POD_RETAILER_CHECKOUT: undefined,
  FAIRE_POD_RETAILER_ACQUISITION: `7c3987b6-6c09-4dd5-bcb5-b4670c6acf40`,
  FAIRE_POD_RETAILER_EVALUATE: undefined,
  FAIRE_POD_FAIRE_DIRECT_REWARDS: undefined,
  FAIRE_POD_FAIRE_DIRECT_CRM: undefined,
  FAIRE_POD_FAIRE_DIRECT_PROSPECTING: undefined,
  FAIRE_POD_APPAREL_INTEGRATIONS: undefined,
  FAIRE_POD_BRAND_F30D_LIFECYCLE: undefined,
  FAIRE_POD_INTERNATIONAL_TRANSLATION: undefined,
  FAIRE_POD_INVOICING_AND_SUPPORT_EXPERIENCE: undefined,
  FAIRE_POD_VAT_INTL_CX: undefined,
  FAIRE_POD_INTERNATIONAL_CX: undefined,
  FAIRE_POD_XB_SHIPPING: undefined,
  FAIRE_POD_SHIPPING_EXPERIENCE: undefined,
  FAIRE_POD_RETAILER_INFRASTRUCTURE: undefined,
  FAIRE_POD_RETAILER_TAXONOMY: undefined,
  FAIRE_POD_FOOD_AND_BEVERAGE: undefined,
  FAIRE_POD_UPMARKET_GROWTH: undefined,
  FAIRE_POD_UPMARKET_EXPERIENCE: undefined,
  FAIRE_POD_FREIGHT_MARGIN: undefined,
  FAIRE_POD_RETAILER_REORDER: undefined,
  FAIRE_POD_BRAND_ENTERPRISE: undefined,
  FAIRE_POD_SLATE_DESIGN_SYSTEM: undefined,
  FAIRE_POD_DESIGN_PLATFORM: `7bbd5589-f944-41e6-bff3-5bdca0632f49`,
  FAIRE_POD_SEARCH_INFRASTRUCTURE: undefined,
  FAIRE_POD_RETAILER_CART_SERVICE: undefined,
  FAIRE_POD_UPMARKET_TEAM_MANAGEMENT: undefined,
  FAIRE_POD_UPMARKET_TOOLING: undefined,
  FAIRE_POD_RETENTION_EXPERIENCE: undefined,
  FAIRE_POD_RETAILER_SEO: undefined,
  FAIRE_POD_BRAND_SERVICE_STANDARDS: undefined,
  FAIRE_POD_SUPPLY_INTEGRITY: undefined,
  FAIRE_POD_RETAILER_SUCCESS: undefined,
  FAIRE_POD_THEMATIC_DISCOVERY: undefined,
  FAIRE_POD_TAXONOMY: undefined,
  FAIRE_POD_SEARCH_EXPERIENCE: undefined,
  FAIRE_POD_INSPIRE: `b97c2d8b-b1d0-4e2c-ba31-9ab133bcd418`,
  FAIRE_POD_SEARCH_RANKING_ALGORITHMS: `0aa0a227-e74a-4909-88a7-0ba23d05cfc7`,
  FAIRE_POD_DISCOVERY_PAID_PLACEMENT: undefined,
  FAIRE_POD_GROWTH_MOBILE: `702c2b11-4e04-43e5-9804-63fbdd607e74`,
  FAIRE_POD_COMMUNICATIONS_PLATFORM: undefined,
  FAIRE_POD_OPEN_WITH_FAIRE: undefined,
  FAIRE_POD_COMMISSION: undefined,
  FAIRE_POD_FAIRE_DIRECT_GROWTH: `a7609eb2-b9e9-491f-8fd4-29086bb208be`,
  FAIRE_POD_SHOPIFY: undefined,
  FAIRE_POD_RETAILER_POS_INTEGRATIONS: undefined,
  FAIRE_POD_RETAILER_TOFU: undefined,
  FAIRE_POD_BROWSE: undefined,
  FAIRE_POD_DATA_TEAM_FINANCIAL_PRODUCTS: `eb06e33c-8466-4b87-8b9e-5ef35a5e679c`,
  FAIRE_POD_RECOMMENDATIONS: undefined,
  FAIRE_POD_SEARCH_EXPERIENCE_ACCELERATOR: undefined,
  FAIRE_POD_INTERNATIONAL_FOUNDATIONS: undefined,
  FAIRE_POD_SUPPORT_EXPERIENCE: undefined,
  FAIRE_POD_BRAND_CATALOG_COMPLETENESS: undefined,
  FAIRE_POD_GROWTH_PLATFORM: `19a821c5-350c-4632-bbd7-a34e7f86df3e`,
  FAIRE_POD_RETAILER_ORDER_PLACEMENT: undefined,
  FAIRE_POD_RETAILER_ORDER_MANAGEMENT: undefined,
  FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT: undefined,
  FAIRE_POD_BRAND_PRICING_AND_REORDERS: undefined,
  FAIRE_POD_BRAND_CATALOG_COMPLETENESS_AND_BRAND_PROGRAMS: undefined,
  FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES: `6bc0d6b8-ca4c-4c28-9a0c-bf863725dd0a`,
  FAIRE_POD_DISCOVERY_INFRA_ENABLEMENT: `d77c3523-4b4c-4dee-a0be-2a6af98af09e`,
  FAIRE_POD_EXPERIMENT_PLATFORM: undefined,
  FAIRE_POD_KNOWLEDGE_GRAPH: undefined,
  FAIRE_POD_PLATFORM_PRODUCTIVITY: undefined,
  FAIRE_POD_DISCOVERY_PRODUCT_PLATFORM: `90d96e6c-bbbf-4f35-a6b1-713aa016884a`,
  FAIRE_POD_PERSONALIZATION: `cab31ae0-402d-49b0-9635-b21e2f1d1df7`,
  FAIRE_POD_BRAND_CATALOG_GROWTH: `820184ef-f1d2-4be3-bd7b-68e76808ca03`,
  FAIRE_POD_SEARCH_QUERY_UNDERSTANDING_AND_RETRIEVAL: `96994d9c-bc6d-4794-bd46-84ea64fc1874`,
  FAIRE_POD_CORE_DATA_INFRA: `694edd23-cdbc-4e12-b3fc-b563216958f4`,
  FAIRE_POD_PP_ADS_MANAGER: undefined,
  FAIRE_POD_PP_ADS_DELIVERY: undefined,
  FAIRE_POD_RETAILER_GROWTH_DATA_SCIENCE: `06e06568-3e37-4f3d-a06d-82a389347b7c`,
  FAIRE_POD_BRAND_DATA_SCIENCE: `1b48f880-735b-4ce2-94bd-e4a2177482c8`,
  FAIRE_POD_DATA_TEAM_INSIDER_AND_SHIPPING_COSTS: undefined,
  FAIRE_POD_VALUE_MOBILE: `6ebe4ad6-0d7c-4444-94d4-74c0ad11c12e`,
  FAIRE_POD_AI_PLATFORM: `957b1259-0ff5-4bd4-b6b2-8ad0b3c779df`,
  FAIRE_POD_OPS_ENABLEMENT: undefined,
  FAIRE_POD_EVALUATE: `1b81f7c5-4377-4ef3-8479-c17651a12039`,
  FAIRE_POD_ADS: undefined,
  FAIRE_POD_ADS_DELIVERY: `34de2cca-45d1-45a5-859c-65a94dbcb364`,
  FAIRE_POD_ADS_MANAGER: undefined,
  FAIRE_POD_ADVERTISER_GROWTH: `63aa4b6a-7596-4531-99fd-38994633ea61`,
  FAIRE_POD_ADS_BIDDING: `e8539839-2845-4051-aef1-7651b09bed32`,
  FAIRE_POD_BRAND_PLATFORM: `fe045131-fac1-4f69-beec-763cb7c1e265`,
  FAIRE_POD_BRAND_PLATFORM_COMPLIANCE: `9dccd0f1-ce0c-43c1-b586-f47f6dbf4175`,
  FAIRE_POD_ORDERS_MIGRATION: undefined,
  FAIRE_POD_FAIRE_PAY: `5f5c3d69-56e5-4b0b-87fc-fb657303739d`,
  FAIRE_POD_ONE_STOP_SHOP: undefined,
  FAIRE_POD_MARKETS_COORDINATION: undefined,
  FAIRE_POD_FULFILLED_BY_FAIRE: undefined,
  FAIRE_POD_FULFILLMENT: `79e03dfd-55b4-41f1-85b0-616cc50f960f`,
  FAIRE_POD_SEARCH_UX: undefined,
  FAIRE_POD_RELATIONSHIP_GROWTH: `5d55d81e-2957-4509-9ca7-25c7745068c0`,
  FAIRE_POD_RETAILER_EXPERIENCE: undefined,
  FAIRE_POD_UPMARKET_PLUS: `c55ac511-2721-4cdb-a9bf-d0d595df9f7c`,
  FAIRE_POD_ANALYTICS_PLATFORM: `0c0b8411-3504-4827-90a8-3d5a8cf9be8b`,
  FAIRE_POD_VALUE_PLATFORM: `5314221a-273d-46be-ad08-c79cdcfec2e1`,
  FAIRE_POD_PLATFORM_CODE_AUTHORING: `1e1f0114-a23a-4822-8ec8-4581f2f70f78`,
  FAIRE_POD_PLATFORM_CODE_REVIEW: `89412044-eab9-4b86-80c6-3cf0629dea5e`,
  FAIRE_POD_PLATFORM_CODE_RELEASE: `93de0071-ad89-4f7f-8d53-717e3e09e118`,
  FAIRE_POD_FINTECH_AND_OPS: `2c90c899-b327-4a39-acf1-3ff11e353210`,
  FAIRE_POD_SEARCH_FX: `058b741c-c54e-4737-9b36-5b6e889a4e6a`,
  FAIRE_POD_CLIENT_PLATFORM: undefined,
  FAIRE_POD_CLIENT_FOUNDATIONS: `d7464e7d-c2fc-4eae-8601-c2d17d653b48`,
  FAIRE_POD_MARKETING_OPERATIONS: `be1472da-3301-499f-94d1-4f8a50ce9190`,
  FAIRE_POD_APP: `9edfd771-c8bf-42e6-ac14-f99761df9703`,
  FAIRE_POD_ORDER_REORDER: `d532aafb-2a4c-4845-b0a0-4f1c46558fa3`,
  FAIRE_POD_OPENING_SOON: `44723e24-4d28-4a58-9ced-60cae9f9303c`,
  FAIRE_POD_ADS_SUPPLY: `e28fc6f0-246c-44b5-ad01-33879ae34230`,
  FAIRE_POD_COMPASS: `855fc665-b471-47b3-9f8b-14b8ac7b70dd`,
  FAIRE_POD_PREORDERS_AND_CUSTOM: `7357f0d2-8557-4b79-9357-7a97035a9823`,
};

export const getLinearTeamIdForFairePod = (
  enumValue: FairePod | keyof typeof FairePod
): string | undefined => {
  return linearTeamIdForFairePod[enumValue];
};

const linearNameOverrideForFairePod: Partial<Record<FairePod, string>> = {
  FAIRE_POD_UNKNOWN: undefined,
  FAIRE_POD_ANTI_ABUSE: undefined,
  FAIRE_POD_APPAREL: undefined,
  FAIRE_POD_APPAREL_BRAND: undefined,
  FAIRE_POD_APPAREL_EVENTS: undefined,
  FAIRE_POD_APPAREL_PREORDER: undefined,
  FAIRE_POD_APPAREL_RETAILER: undefined,
  FAIRE_POD_BRAND_ACQUISITION: undefined,
  FAIRE_POD_BRAND_GROWTH: undefined,
  FAIRE_POD_BRAND_MARKETPLACE_QUALITY: undefined,
  FAIRE_POD_BRAND_ONBOARDING: undefined,
  FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM: `Brand Onboarding and Activation Team`,
  FAIRE_POD_BRAND_ORDER_MANAGEMENT: undefined,
  FAIRE_POD_BRAND_FAIRE_DIRECT: undefined,
  FAIRE_POD_CATEGORY_INCUBATION: undefined,
  FAIRE_POD_DATA: undefined,
  FAIRE_POD_DISCOVERY_AI: `Discovery AI`,
  FAIRE_POD_DISCOVERY_AE: `Discovery PAE`,
  FAIRE_POD_DISCOVERY_LOGGING: undefined,
  FAIRE_POD_FAIRE_FOUNDATIONS: undefined,
  FAIRE_POD_INTEGRATIONS: undefined,
  FAIRE_POD_INTERNAL_TOOLS: undefined,
  FAIRE_POD_INTERNATIONAL: undefined,
  FAIRE_POD_INTERNATIONAL_BRAND_GROWTH: undefined,
  FAIRE_POD_INTERNATIONAL_BRAND: undefined,
  FAIRE_POD_INTERNATIONAL_LAUNCH: undefined,
  FAIRE_POD_INTERNATIONAL_PLATFORM: undefined,
  FAIRE_POD_MARKETS: undefined,
  FAIRE_POD_RETAILER_PRICING: undefined,
  FAIRE_POD_SHIPPING: `Shipping & Receiving`,
  FAIRE_POD_MARKETPLACE_QUALITY: undefined,
  FAIRE_POD_MOBILE: undefined,
  FAIRE_POD_MOBILE_STRIKE: undefined,
  FAIRE_POD_MOBILE_CORE: undefined,
  FAIRE_POD_MOBILE_PLATFORM: undefined,
  FAIRE_POD_MOBILE_EXPANSION: undefined,
  FAIRE_POD_MOBILE_INTERNATIONAL: undefined,
  FAIRE_POD_MULTI_SERVICE: undefined,
  FAIRE_POD_PLATFORM: undefined,
  FAIRE_POD_PLATFORM_CONTROL: undefined,
  FAIRE_POD_PLATFORM_SCALE: undefined,
  FAIRE_POD_PLATFORM_RELIABILITY: undefined,
  FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS: `Performance and Insights`,
  FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCE: undefined,
  FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY: `Infrastructure and Resiliency`,
  FAIRE_POD_PLATFORM_TAP: undefined,
  FAIRE_POD_BRAND_INFRASTRUCTURE: undefined,
  FAIRE_POD_PREORDERS: undefined,
  FAIRE_POD_PRICING: undefined,
  FAIRE_POD_BRAND_PRICING: undefined,
  FAIRE_POD_QUALITY: undefined,
  FAIRE_POD_RISK: undefined,
  FAIRE_POD_SECURITY: undefined,
  FAIRE_POD_RETAILER_LIFECYCLE: undefined,
  FAIRE_POD_RETAILER_CONFIDENCE: undefined,
  FAIRE_POD_RETAILER_GROWTH: undefined,
  FAIRE_POD_RETAILER_ACTIVATION: undefined,
  FAIRE_POD_RETAILER_ONBOARDING: undefined,
  FAIRE_POD_RETAILER_DISCOVERY: undefined,
  FAIRE_POD_INSIDER: undefined,
  FAIRE_POD_UNASSIGNED: undefined,
  FAIRE_POD_BRAND_UNASSIGNED: undefined,
  FAIRE_POD_WEB_PLATFORM: undefined,
  FAIRE_POD_CLIENT_TOOLS: undefined,
  FAIRE_POD_RETAILER_UNDERWRITING: undefined,
  FAIRE_POD_ORDER_WRITING: undefined,
  FAIRE_POD_LOCALIZATION: undefined,
  FAIRE_POD_BRAND_MARKETPLACE_SUCCESS: undefined,
  FAIRE_POD_STABLE_STAPLES: undefined,
  FAIRE_POD_FINANCIAL_PRODUCTS: undefined,
  FAIRE_POD_UPMARKET: undefined,
  FAIRE_POD_RETAILER_INSPIRE: undefined,
  FAIRE_POD_RETAILER_SEARCH: undefined,
  FAIRE_POD_RETAILER_CHECKOUT: undefined,
  FAIRE_POD_RETAILER_ACQUISITION: undefined,
  FAIRE_POD_RETAILER_EVALUATE: undefined,
  FAIRE_POD_FAIRE_DIRECT_REWARDS: undefined,
  FAIRE_POD_FAIRE_DIRECT_CRM: undefined,
  FAIRE_POD_FAIRE_DIRECT_PROSPECTING: undefined,
  FAIRE_POD_APPAREL_INTEGRATIONS: undefined,
  FAIRE_POD_BRAND_F30D_LIFECYCLE: undefined,
  FAIRE_POD_INTERNATIONAL_TRANSLATION: undefined,
  FAIRE_POD_INVOICING_AND_SUPPORT_EXPERIENCE: undefined,
  FAIRE_POD_VAT_INTL_CX: undefined,
  FAIRE_POD_INTERNATIONAL_CX: undefined,
  FAIRE_POD_XB_SHIPPING: undefined,
  FAIRE_POD_SHIPPING_EXPERIENCE: undefined,
  FAIRE_POD_RETAILER_INFRASTRUCTURE: undefined,
  FAIRE_POD_RETAILER_TAXONOMY: undefined,
  FAIRE_POD_FOOD_AND_BEVERAGE: undefined,
  FAIRE_POD_UPMARKET_GROWTH: undefined,
  FAIRE_POD_UPMARKET_EXPERIENCE: undefined,
  FAIRE_POD_FREIGHT_MARGIN: undefined,
  FAIRE_POD_RETAILER_REORDER: undefined,
  FAIRE_POD_BRAND_ENTERPRISE: undefined,
  FAIRE_POD_SLATE_DESIGN_SYSTEM: undefined,
  FAIRE_POD_DESIGN_PLATFORM: undefined,
  FAIRE_POD_SEARCH_INFRASTRUCTURE: undefined,
  FAIRE_POD_RETAILER_CART_SERVICE: undefined,
  FAIRE_POD_UPMARKET_TEAM_MANAGEMENT: undefined,
  FAIRE_POD_UPMARKET_TOOLING: undefined,
  FAIRE_POD_RETENTION_EXPERIENCE: undefined,
  FAIRE_POD_RETAILER_SEO: undefined,
  FAIRE_POD_BRAND_SERVICE_STANDARDS: undefined,
  FAIRE_POD_SUPPLY_INTEGRITY: undefined,
  FAIRE_POD_RETAILER_SUCCESS: undefined,
  FAIRE_POD_THEMATIC_DISCOVERY: undefined,
  FAIRE_POD_TAXONOMY: undefined,
  FAIRE_POD_SEARCH_EXPERIENCE: undefined,
  FAIRE_POD_INSPIRE: undefined,
  FAIRE_POD_SEARCH_RANKING_ALGORITHMS: `Search Ranking Algorithm`,
  FAIRE_POD_DISCOVERY_PAID_PLACEMENT: undefined,
  FAIRE_POD_GROWTH_MOBILE: undefined,
  FAIRE_POD_COMMUNICATIONS_PLATFORM: undefined,
  FAIRE_POD_OPEN_WITH_FAIRE: undefined,
  FAIRE_POD_COMMISSION: undefined,
  FAIRE_POD_FAIRE_DIRECT_GROWTH: `Brand Wholesale Platform`,
  FAIRE_POD_SHOPIFY: undefined,
  FAIRE_POD_RETAILER_POS_INTEGRATIONS: undefined,
  FAIRE_POD_RETAILER_TOFU: undefined,
  FAIRE_POD_BROWSE: undefined,
  FAIRE_POD_DATA_TEAM_FINANCIAL_PRODUCTS: undefined,
  FAIRE_POD_RECOMMENDATIONS: undefined,
  FAIRE_POD_SEARCH_EXPERIENCE_ACCELERATOR: undefined,
  FAIRE_POD_INTERNATIONAL_FOUNDATIONS: undefined,
  FAIRE_POD_SUPPORT_EXPERIENCE: undefined,
  FAIRE_POD_BRAND_CATALOG_COMPLETENESS: undefined,
  FAIRE_POD_GROWTH_PLATFORM: undefined,
  FAIRE_POD_RETAILER_ORDER_PLACEMENT: undefined,
  FAIRE_POD_RETAILER_ORDER_MANAGEMENT: undefined,
  FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT: undefined,
  FAIRE_POD_BRAND_PRICING_AND_REORDERS: undefined,
  FAIRE_POD_BRAND_CATALOG_COMPLETENESS_AND_BRAND_PROGRAMS: undefined,
  FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES: `Listing Quality`,
  FAIRE_POD_DISCOVERY_INFRA_ENABLEMENT: `Discovery Infra and Enablement`,
  FAIRE_POD_EXPERIMENT_PLATFORM: undefined,
  FAIRE_POD_KNOWLEDGE_GRAPH: undefined,
  FAIRE_POD_PLATFORM_PRODUCTIVITY: undefined,
  FAIRE_POD_DISCOVERY_PRODUCT_PLATFORM: undefined,
  FAIRE_POD_PERSONALIZATION: undefined,
  FAIRE_POD_BRAND_CATALOG_GROWTH: `Catalog Growth`,
  FAIRE_POD_SEARCH_QUERY_UNDERSTANDING_AND_RETRIEVAL: `Search Query Understanding and Retrieval Algorithm`,
  FAIRE_POD_CORE_DATA_INFRA: `Core Data Infrastructure`,
  FAIRE_POD_PP_ADS_MANAGER: undefined,
  FAIRE_POD_PP_ADS_DELIVERY: undefined,
  FAIRE_POD_RETAILER_GROWTH_DATA_SCIENCE: `Retailer Growth DSPA`,
  FAIRE_POD_BRAND_DATA_SCIENCE: `Brand DS`,
  FAIRE_POD_DATA_TEAM_INSIDER_AND_SHIPPING_COSTS: undefined,
  FAIRE_POD_VALUE_MOBILE: undefined,
  FAIRE_POD_AI_PLATFORM: `Machine Learning Platform`,
  FAIRE_POD_OPS_ENABLEMENT: undefined,
  FAIRE_POD_EVALUATE: undefined,
  FAIRE_POD_ADS: undefined,
  FAIRE_POD_ADS_DELIVERY: undefined,
  FAIRE_POD_ADS_MANAGER: undefined,
  FAIRE_POD_ADVERTISER_GROWTH: undefined,
  FAIRE_POD_ADS_BIDDING: undefined,
  FAIRE_POD_BRAND_PLATFORM: undefined,
  FAIRE_POD_BRAND_PLATFORM_COMPLIANCE: undefined,
  FAIRE_POD_ORDERS_MIGRATION: undefined,
  FAIRE_POD_FAIRE_PAY: undefined,
  FAIRE_POD_ONE_STOP_SHOP: undefined,
  FAIRE_POD_MARKETS_COORDINATION: undefined,
  FAIRE_POD_FULFILLED_BY_FAIRE: undefined,
  FAIRE_POD_FULFILLMENT: undefined,
  FAIRE_POD_SEARCH_UX: undefined,
  FAIRE_POD_RELATIONSHIP_GROWTH: undefined,
  FAIRE_POD_RETAILER_EXPERIENCE: undefined,
  FAIRE_POD_UPMARKET_PLUS: undefined,
  FAIRE_POD_ANALYTICS_PLATFORM: undefined,
  FAIRE_POD_VALUE_PLATFORM: undefined,
  FAIRE_POD_PLATFORM_CODE_AUTHORING: `Code Authoring`,
  FAIRE_POD_PLATFORM_CODE_REVIEW: `Code Review`,
  FAIRE_POD_PLATFORM_CODE_RELEASE: `Code Release`,
  FAIRE_POD_FINTECH_AND_OPS: `Fintech and Ops`,
  FAIRE_POD_SEARCH_FX: `Search FX`,
  FAIRE_POD_CLIENT_PLATFORM: undefined,
  FAIRE_POD_CLIENT_FOUNDATIONS: undefined,
  FAIRE_POD_MARKETING_OPERATIONS: undefined,
  FAIRE_POD_APP: undefined,
  FAIRE_POD_ORDER_REORDER: `Order/Reorder`,
  FAIRE_POD_OPENING_SOON: undefined,
  FAIRE_POD_ADS_SUPPLY: undefined,
  FAIRE_POD_COMPASS: undefined,
  FAIRE_POD_PREORDERS_AND_CUSTOM: undefined,
};

export const getLinearNameOverrideForFairePod = (
  enumValue: FairePod | keyof typeof FairePod
): string | undefined => {
  return linearNameOverrideForFairePod[enumValue];
};

const jiraNameOverrideForFairePod: Partial<Record<FairePod, string>> = {
  FAIRE_POD_UNKNOWN: undefined,
  FAIRE_POD_ANTI_ABUSE: undefined,
  FAIRE_POD_APPAREL: undefined,
  FAIRE_POD_APPAREL_BRAND: undefined,
  FAIRE_POD_APPAREL_EVENTS: undefined,
  FAIRE_POD_APPAREL_PREORDER: undefined,
  FAIRE_POD_APPAREL_RETAILER: undefined,
  FAIRE_POD_BRAND_ACQUISITION: undefined,
  FAIRE_POD_BRAND_GROWTH: undefined,
  FAIRE_POD_BRAND_MARKETPLACE_QUALITY: undefined,
  FAIRE_POD_BRAND_ONBOARDING: undefined,
  FAIRE_POD_BRAND_ONBOARDING_AND_ACTIVATION_TEAM: undefined,
  FAIRE_POD_BRAND_ORDER_MANAGEMENT: undefined,
  FAIRE_POD_BRAND_FAIRE_DIRECT: undefined,
  FAIRE_POD_CATEGORY_INCUBATION: undefined,
  FAIRE_POD_DATA: undefined,
  FAIRE_POD_DISCOVERY_AI: undefined,
  FAIRE_POD_DISCOVERY_AE: undefined,
  FAIRE_POD_DISCOVERY_LOGGING: undefined,
  FAIRE_POD_FAIRE_FOUNDATIONS: undefined,
  FAIRE_POD_INTEGRATIONS: undefined,
  FAIRE_POD_INTERNAL_TOOLS: undefined,
  FAIRE_POD_INTERNATIONAL: undefined,
  FAIRE_POD_INTERNATIONAL_BRAND_GROWTH: undefined,
  FAIRE_POD_INTERNATIONAL_BRAND: undefined,
  FAIRE_POD_INTERNATIONAL_LAUNCH: undefined,
  FAIRE_POD_INTERNATIONAL_PLATFORM: undefined,
  FAIRE_POD_MARKETS: undefined,
  FAIRE_POD_RETAILER_PRICING: undefined,
  FAIRE_POD_SHIPPING: undefined,
  FAIRE_POD_MARKETPLACE_QUALITY: undefined,
  FAIRE_POD_MOBILE: undefined,
  FAIRE_POD_MOBILE_STRIKE: undefined,
  FAIRE_POD_MOBILE_CORE: undefined,
  FAIRE_POD_MOBILE_PLATFORM: undefined,
  FAIRE_POD_MOBILE_EXPANSION: undefined,
  FAIRE_POD_MOBILE_INTERNATIONAL: undefined,
  FAIRE_POD_MULTI_SERVICE: undefined,
  FAIRE_POD_PLATFORM: undefined,
  FAIRE_POD_PLATFORM_CONTROL: undefined,
  FAIRE_POD_PLATFORM_SCALE: undefined,
  FAIRE_POD_PLATFORM_RELIABILITY: undefined,
  FAIRE_POD_PLATFORM_PERFORMANCE_AND_INSIGHTS: undefined,
  FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCE: undefined,
  FAIRE_POD_PLATFORM_INFRASTRUCTURE_AND_RESILIENCY: undefined,
  FAIRE_POD_PLATFORM_TAP: undefined,
  FAIRE_POD_BRAND_INFRASTRUCTURE: undefined,
  FAIRE_POD_PREORDERS: undefined,
  FAIRE_POD_PRICING: undefined,
  FAIRE_POD_BRAND_PRICING: undefined,
  FAIRE_POD_QUALITY: undefined,
  FAIRE_POD_RISK: undefined,
  FAIRE_POD_SECURITY: undefined,
  FAIRE_POD_RETAILER_LIFECYCLE: undefined,
  FAIRE_POD_RETAILER_CONFIDENCE: undefined,
  FAIRE_POD_RETAILER_GROWTH: undefined,
  FAIRE_POD_RETAILER_ACTIVATION: undefined,
  FAIRE_POD_RETAILER_ONBOARDING: undefined,
  FAIRE_POD_RETAILER_DISCOVERY: undefined,
  FAIRE_POD_INSIDER: undefined,
  FAIRE_POD_UNASSIGNED: undefined,
  FAIRE_POD_BRAND_UNASSIGNED: undefined,
  FAIRE_POD_WEB_PLATFORM: undefined,
  FAIRE_POD_CLIENT_TOOLS: undefined,
  FAIRE_POD_RETAILER_UNDERWRITING: undefined,
  FAIRE_POD_ORDER_WRITING: undefined,
  FAIRE_POD_LOCALIZATION: undefined,
  FAIRE_POD_BRAND_MARKETPLACE_SUCCESS: undefined,
  FAIRE_POD_STABLE_STAPLES: undefined,
  FAIRE_POD_FINANCIAL_PRODUCTS: undefined,
  FAIRE_POD_UPMARKET: undefined,
  FAIRE_POD_RETAILER_INSPIRE: undefined,
  FAIRE_POD_RETAILER_SEARCH: undefined,
  FAIRE_POD_RETAILER_CHECKOUT: undefined,
  FAIRE_POD_RETAILER_ACQUISITION: undefined,
  FAIRE_POD_RETAILER_EVALUATE: undefined,
  FAIRE_POD_FAIRE_DIRECT_REWARDS: undefined,
  FAIRE_POD_FAIRE_DIRECT_CRM: undefined,
  FAIRE_POD_FAIRE_DIRECT_PROSPECTING: undefined,
  FAIRE_POD_APPAREL_INTEGRATIONS: undefined,
  FAIRE_POD_BRAND_F30D_LIFECYCLE: undefined,
  FAIRE_POD_INTERNATIONAL_TRANSLATION: undefined,
  FAIRE_POD_INVOICING_AND_SUPPORT_EXPERIENCE: undefined,
  FAIRE_POD_VAT_INTL_CX: undefined,
  FAIRE_POD_INTERNATIONAL_CX: undefined,
  FAIRE_POD_XB_SHIPPING: undefined,
  FAIRE_POD_SHIPPING_EXPERIENCE: undefined,
  FAIRE_POD_RETAILER_INFRASTRUCTURE: undefined,
  FAIRE_POD_RETAILER_TAXONOMY: undefined,
  FAIRE_POD_FOOD_AND_BEVERAGE: undefined,
  FAIRE_POD_UPMARKET_GROWTH: undefined,
  FAIRE_POD_UPMARKET_EXPERIENCE: undefined,
  FAIRE_POD_FREIGHT_MARGIN: undefined,
  FAIRE_POD_RETAILER_REORDER: undefined,
  FAIRE_POD_BRAND_ENTERPRISE: undefined,
  FAIRE_POD_SLATE_DESIGN_SYSTEM: undefined,
  FAIRE_POD_DESIGN_PLATFORM: undefined,
  FAIRE_POD_SEARCH_INFRASTRUCTURE: undefined,
  FAIRE_POD_RETAILER_CART_SERVICE: undefined,
  FAIRE_POD_UPMARKET_TEAM_MANAGEMENT: undefined,
  FAIRE_POD_UPMARKET_TOOLING: undefined,
  FAIRE_POD_RETENTION_EXPERIENCE: undefined,
  FAIRE_POD_RETAILER_SEO: undefined,
  FAIRE_POD_BRAND_SERVICE_STANDARDS: undefined,
  FAIRE_POD_SUPPLY_INTEGRITY: undefined,
  FAIRE_POD_RETAILER_SUCCESS: undefined,
  FAIRE_POD_THEMATIC_DISCOVERY: undefined,
  FAIRE_POD_TAXONOMY: undefined,
  FAIRE_POD_SEARCH_EXPERIENCE: undefined,
  FAIRE_POD_INSPIRE: undefined,
  FAIRE_POD_SEARCH_RANKING_ALGORITHMS: undefined,
  FAIRE_POD_DISCOVERY_PAID_PLACEMENT: undefined,
  FAIRE_POD_GROWTH_MOBILE: undefined,
  FAIRE_POD_COMMUNICATIONS_PLATFORM: undefined,
  FAIRE_POD_OPEN_WITH_FAIRE: undefined,
  FAIRE_POD_COMMISSION: undefined,
  FAIRE_POD_FAIRE_DIRECT_GROWTH: undefined,
  FAIRE_POD_SHOPIFY: undefined,
  FAIRE_POD_RETAILER_POS_INTEGRATIONS: undefined,
  FAIRE_POD_RETAILER_TOFU: undefined,
  FAIRE_POD_BROWSE: undefined,
  FAIRE_POD_DATA_TEAM_FINANCIAL_PRODUCTS: undefined,
  FAIRE_POD_RECOMMENDATIONS: undefined,
  FAIRE_POD_SEARCH_EXPERIENCE_ACCELERATOR: undefined,
  FAIRE_POD_INTERNATIONAL_FOUNDATIONS: undefined,
  FAIRE_POD_SUPPORT_EXPERIENCE: undefined,
  FAIRE_POD_BRAND_CATALOG_COMPLETENESS: undefined,
  FAIRE_POD_GROWTH_PLATFORM: undefined,
  FAIRE_POD_RETAILER_ORDER_PLACEMENT: undefined,
  FAIRE_POD_RETAILER_ORDER_MANAGEMENT: `Retailer POS Integrations`,
  FAIRE_POD_BRAND_OPERATIONS_MANAGEMENT: `BOM`,
  FAIRE_POD_BRAND_PRICING_AND_REORDERS: undefined,
  FAIRE_POD_BRAND_CATALOG_COMPLETENESS_AND_BRAND_PROGRAMS: undefined,
  FAIRE_POD_BRAND_LISTING_QUALITY_AND_PRODUCT_ATTRIBUTES: undefined,
  FAIRE_POD_DISCOVERY_INFRA_ENABLEMENT: undefined,
  FAIRE_POD_EXPERIMENT_PLATFORM: undefined,
  FAIRE_POD_KNOWLEDGE_GRAPH: undefined,
  FAIRE_POD_PLATFORM_PRODUCTIVITY: `Platform Productivity`,
  FAIRE_POD_DISCOVERY_PRODUCT_PLATFORM: undefined,
  FAIRE_POD_PERSONALIZATION: undefined,
  FAIRE_POD_BRAND_CATALOG_GROWTH: undefined,
  FAIRE_POD_SEARCH_QUERY_UNDERSTANDING_AND_RETRIEVAL: undefined,
  FAIRE_POD_CORE_DATA_INFRA: undefined,
  FAIRE_POD_PP_ADS_MANAGER: undefined,
  FAIRE_POD_PP_ADS_DELIVERY: undefined,
  FAIRE_POD_RETAILER_GROWTH_DATA_SCIENCE: undefined,
  FAIRE_POD_BRAND_DATA_SCIENCE: undefined,
  FAIRE_POD_DATA_TEAM_INSIDER_AND_SHIPPING_COSTS: undefined,
  FAIRE_POD_VALUE_MOBILE: undefined,
  FAIRE_POD_AI_PLATFORM: `Machine Learning Platform`,
  FAIRE_POD_OPS_ENABLEMENT: undefined,
  FAIRE_POD_EVALUATE: undefined,
  FAIRE_POD_ADS: undefined,
  FAIRE_POD_ADS_DELIVERY: undefined,
  FAIRE_POD_ADS_MANAGER: undefined,
  FAIRE_POD_ADVERTISER_GROWTH: undefined,
  FAIRE_POD_ADS_BIDDING: undefined,
  FAIRE_POD_BRAND_PLATFORM: undefined,
  FAIRE_POD_BRAND_PLATFORM_COMPLIANCE: undefined,
  FAIRE_POD_ORDERS_MIGRATION: undefined,
  FAIRE_POD_FAIRE_PAY: undefined,
  FAIRE_POD_ONE_STOP_SHOP: undefined,
  FAIRE_POD_MARKETS_COORDINATION: undefined,
  FAIRE_POD_FULFILLED_BY_FAIRE: undefined,
  FAIRE_POD_FULFILLMENT: undefined,
  FAIRE_POD_SEARCH_UX: undefined,
  FAIRE_POD_RELATIONSHIP_GROWTH: undefined,
  FAIRE_POD_RETAILER_EXPERIENCE: undefined,
  FAIRE_POD_UPMARKET_PLUS: undefined,
  FAIRE_POD_ANALYTICS_PLATFORM: undefined,
  FAIRE_POD_VALUE_PLATFORM: undefined,
  FAIRE_POD_PLATFORM_CODE_AUTHORING: undefined,
  FAIRE_POD_PLATFORM_CODE_REVIEW: undefined,
  FAIRE_POD_PLATFORM_CODE_RELEASE: undefined,
  FAIRE_POD_FINTECH_AND_OPS: undefined,
  FAIRE_POD_SEARCH_FX: undefined,
  FAIRE_POD_CLIENT_PLATFORM: undefined,
  FAIRE_POD_CLIENT_FOUNDATIONS: undefined,
  FAIRE_POD_MARKETING_OPERATIONS: undefined,
  FAIRE_POD_APP: undefined,
  FAIRE_POD_ORDER_REORDER: undefined,
  FAIRE_POD_OPENING_SOON: undefined,
  FAIRE_POD_ADS_SUPPLY: undefined,
  FAIRE_POD_COMPASS: undefined,
  FAIRE_POD_PREORDERS_AND_CUSTOM: undefined,
};

export const getJiraNameOverrideForFairePod = (
  enumValue: FairePod | keyof typeof FairePod
): string | undefined => {
  return jiraNameOverrideForFairePod[enumValue];
};
